(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
// Main Web Audio API module, takes care of creating and resuming
// Audio context, maintaining sources and providing some effects.
var $cdce0d2b992d5ef2$exports = {};

$parcel$export($cdce0d2b992d5ef2$exports, "load", function () { return $cdce0d2b992d5ef2$export$11e63f7b0f3d9900; });
$parcel$export($cdce0d2b992d5ef2$exports, "play", function () { return $cdce0d2b992d5ef2$export$899fbdb5fa08b653; });
$parcel$export($cdce0d2b992d5ef2$exports, "audioBuffers", function () { return $cdce0d2b992d5ef2$export$c2a342ec653dfb48; });
// Manages loading, decoding and plaback of audioBuffers

// References
const $cdce0d2b992d5ef2$export$c2a342ec653dfb48 = {};
function $cdce0d2b992d5ef2$export$11e63f7b0f3d9900(name, url, progress = null) {
    const request = new XMLHttpRequest();
    const promise = new Promise((resolve, reject)=>{
        request.open("GET", url, true);
        request.responseType = "arraybuffer";
        request.onload = ()=>{
            if (request.status !== 200) {
                reject();
                console.error(`An error occured while getting '${name}' audio from '${url}', status: ${request.status}`);
                return;
            }
            resolve($cdce0d2b992d5ef2$var$decode(name, request.response));
        };
        request.onerror = ()=>{
            reject();
            console.error(`An error occured while getting '${name}' audio from '${url}'`);
        };
        request.onprogress = (e)=>{
            const percent = Math.round(e.loaded / e.total * 100);
            if (typeof progress === "function") progress(percent);
            if (DEVMODE) console.log(`Progress loading '${name}' audio file`, percent + "%");
        };
        request.send();
    });
    return promise;
}
function $cdce0d2b992d5ef2$var$decode(name, arrayBuffer) {
    const promise = new Promise((resolve, reject)=>{
        $65fe2578b15097c5$export$a078c61943f9dbbe.decodeAudioData(arrayBuffer, (buffer)=>{
            $cdce0d2b992d5ef2$export$c2a342ec653dfb48[name] = buffer;
            resolve();
            if (DEVMODE) console.log(`Decoded '${name}' audio buffer`);
        }, (e)=>{
            reject();
            console.error("Error while decoding audio data: " + e);
        });
    });
    return promise;
}
async function $cdce0d2b992d5ef2$export$899fbdb5fa08b653(name, options = {}) {
    if ($cdce0d2b992d5ef2$export$c2a342ec653dfb48[name] === undefined) {
        console.error(`Play error: '${name}' audio buffer does not exist.`);
        return false;
    }
    await $65fe2578b15097c5$export$fbb4d68fe60c1629();
    // Create a new source
    const source = $65fe2578b15097c5$export$a078c61943f9dbbe.createBufferSource();
    const gainNode = $65fe2578b15097c5$export$a078c61943f9dbbe.createGain();
    if (options.gain != undefined) // Note: this initial gain value will only be applied after that time
    // have passed (it does not change immediately).
    gainNode.gain.setValueAtTime($65fe2578b15097c5$export$33ed28de027e9482(options.gain), $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime);
    source.gainNode = gainNode; // custom property for reference
    source.fadeTo = $65fe2578b15097c5$export$549ee30ac73cf40b; // custom function
    source.fade = $65fe2578b15097c5$export$cbea29d068a2e18f; // custom function
    source.connect(gainNode);
    gainNode.connect(options.destination || $65fe2578b15097c5$export$a078c61943f9dbbe.destination);
    // Optional looping parameters
    source.loop = options.loop || false;
    source.loopStart = options.loopStart || 0;
    source.loopEnd = options.loopEnd || 0;
    // Optional starting parameters
    const when = (options.when || 0) + $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime;
    const offset = options.offset || 0;
    const duration = options.duration || undefined;
    // ... more options to come (detune, playBackRate)?
    // Assign an already loaded and decoded buffer
    source.buffer = $cdce0d2b992d5ef2$export$c2a342ec653dfb48[name];
    // On ended event
    source.onended = ()=>{
        if (typeof options.onended === "function") options.onended();
        $65fe2578b15097c5$export$93c25f2590a5b540(source);
    };
    // Start producing sound
    if (options.defer !== true) source.start(when, offset, duration);
    // Maintain references to this source
    $65fe2578b15097c5$export$d1d41f0cda037248.push(source);
    return source;
}


var $159fa085cd4c746e$exports = {};

$parcel$export($159fa085cd4c746e$exports, "createPanner", function () { return $159fa085cd4c746e$export$604289ae06b8fa82; });
$parcel$export($159fa085cd4c746e$exports, "positionListener", function () { return $159fa085cd4c746e$export$f0551cbb67220cad; });
$parcel$export($159fa085cd4c746e$exports, "orientListener", function () { return $159fa085cd4c746e$export$27298482267e128c; });
$parcel$export($159fa085cd4c746e$exports, "play", function () { return $159fa085cd4c746e$export$899fbdb5fa08b653; });
// Manages audiospatialisation

function $159fa085cd4c746e$export$604289ae06b8fa82(options = {}) {
    const panner = $65fe2578b15097c5$export$a078c61943f9dbbe.createPanner();
    panner.panningModel = "HRTF";
    panner.distanceModel = "exponential";
    panner.refDistance = 1;
    panner.maxDistance = 20;
    panner.rolloffFactor = 2;
    // panner.coneInnerAngle = 360;
    // panner.coneOuterAngle = 0;
    // panner.coneOuterGain = 0;
    if (panner.orientationX) {
        panner.orientationX.setValueAtTime(0, $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime);
        panner.orientationY.setValueAtTime(0, $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime);
        panner.orientationZ.setValueAtTime(-1, $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime);
    } else panner.setOrientation(0, 0, -1);
    panner.positionPanner = function(x, y, z) {
        if (panner.positionX) {
            panner.positionX.setValueAtTime(x, $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime);
            panner.positionY.setValueAtTime(y, $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime);
            panner.positionZ.setValueAtTime(z, $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime);
        } else panner.setPosition(x, y, z);
    };
    panner.connect(options.destination || $65fe2578b15097c5$export$a078c61943f9dbbe.destination);
    return panner;
}
function $159fa085cd4c746e$export$f0551cbb67220cad(x, y, z) {
    const listener = $65fe2578b15097c5$export$a078c61943f9dbbe.listener;
    if (listener.positionX) {
        listener.positionX.setValueAtTime(x, $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime);
        listener.positionY.setValueAtTime(y, $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime);
        listener.positionZ.setValueAtTime(z, $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime);
    } else listener.setPosition(x, y, z);
}
function $159fa085cd4c746e$export$27298482267e128c(direction) {
    // Orient the listener in the direction of the player
    // The direction is given in degrees (0 to 360) in a 2d ground plane
    // Facing the screen is 0, facing right is 90, facing left is -90
    // FIXME: There is no up/down orientation implemented yet
    const deltaAngleX = Math.abs(direction + 90) % 360;
    const deviationX = deltaAngleX < 180 ? deltaAngleX : 360 - deltaAngleX;
    const deltaAngleZ = Math.abs(direction) % 360;
    const deviationZ = deltaAngleZ < 180 ? deltaAngleZ : 360 - deltaAngleZ;
    const fx = deviationX / 180 * 2 - 1;
    const fy = 0;
    const fz = deviationZ / 180 * 2 - 1;
    const ux = 0;
    const uy = 1;
    const uz = 0;
    const listener = $65fe2578b15097c5$export$a078c61943f9dbbe.listener;
    if (listener.forwardX) {
        listener.forwardX.setValueAtTime(fx, $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime);
        listener.forwardY.setValueAtTime(fy, $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime);
        listener.forwardZ.setValueAtTime(fz, $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime);
        listener.upX.setValueAtTime(ux, $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime);
        listener.upY.setValueAtTime(uy, $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime);
        listener.upZ.setValueAtTime(uz, $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime);
    } else listener.setOrientation(fx, fy, fz, ux, uy, uz);
}
function $159fa085cd4c746e$export$899fbdb5fa08b653(p) {
    // p for POI
    const panner = $159fa085cd4c746e$export$604289ae06b8fa82();
    panner.positionPanner(p.position.x, p.position.z, p.position.y);
    p.sound.panner = panner;
    $cdce0d2b992d5ef2$exports.play(p.sound.name, {
        // TODO: this should probably merged with defaults in buffers.js
        gain: p.sound.gain || 0,
        loop: p.sound.loop || true,
        when: p.sound.when || 0,
        destination: panner,
        defer: p.sound.defer
    }).then((source)=>{
        p.sound.source = source;
    });
}


// References
let $65fe2578b15097c5$export$a078c61943f9dbbe;
const $65fe2578b15097c5$export$d1d41f0cda037248 = [];
function $65fe2578b15097c5$export$2cd8252107eb640b() {
    // Create AudioContext
    $65fe2578b15097c5$export$a078c61943f9dbbe = new AudioContext();
    if (DEVMODE) console.log("Audio context sample rate: " + $65fe2578b15097c5$export$a078c61943f9dbbe.sampleRate);
}
function $65fe2578b15097c5$export$fbb4d68fe60c1629() {
    // Resume context, dealing with autoplay policy
    if ($65fe2578b15097c5$export$a078c61943f9dbbe.state === "suspended") {
        if (DEVMODE) console.log("Resuming AudioContext");
        return $65fe2578b15097c5$export$a078c61943f9dbbe.resume();
    } else return Promise.resolve();
}
// Fade to an absolute level in db
// Default to a fade in behavior from -90db
// this function is used as a source method 
function $65fe2578b15097c5$export$549ee30ac73cf40b(time = 2, level = 0, fromLevel = -90, mode = "linear") {
    this.gainNode.gain.setValueAtTime($65fe2578b15097c5$export$33ed28de027e9482(fromLevel), $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime);
    if (mode === "linear") this.gainNode.gain.linearRampToValueAtTime($65fe2578b15097c5$export$33ed28de027e9482(level), $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime + time);
    else this.gainNode.gain.exponentialRampToValueAtTime($65fe2578b15097c5$export$33ed28de027e9482(level), $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime + time);
    return this;
}
// Fade to a new level by applying a relative db gain
// Defaults to a fade out behavior
// this function is used as a source method 
function $65fe2578b15097c5$export$cbea29d068a2e18f(time = 2, db = -90, andStop = false, mode = "linear") {
    const currentGain = this.gainNode.gain.value;
    // This setValueAtTime call below is required for Firefox and Safari.
    // Otherwise, linearRampToValueAtTime will do nothing until
    // ac.currentTime + time is reached and then immeditaley drop to -90db.
    // Is this a bug?
    this.gainNode.gain.setValueAtTime(currentGain, $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime);
    if (mode === "linear") this.gainNode.gain.linearRampToValueAtTime(currentGain * $65fe2578b15097c5$export$33ed28de027e9482(db), $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime + time);
    else this.gainNode.gain.exponentialRampToValueAtTime(currentGain * $65fe2578b15097c5$export$33ed28de027e9482(db), $65fe2578b15097c5$export$a078c61943f9dbbe.currentTime + time);
    if (andStop) this.stop($65fe2578b15097c5$export$a078c61943f9dbbe.currentTime + time);
    return this;
}
function $65fe2578b15097c5$export$51b36263b660c3ee(time = 2, finalGain = -90) {
    // Fade out all sources and stop them
    $65fe2578b15097c5$export$d1d41f0cda037248.forEach((s)=>s.fade(time, finalGain, true));
}
function $65fe2578b15097c5$export$33390c3a9a83a2f() {
    $65fe2578b15097c5$export$d1d41f0cda037248.forEach((s)=>s.stop());
}
function $65fe2578b15097c5$export$93c25f2590a5b540(source) {
    const index = $65fe2578b15097c5$export$d1d41f0cda037248.indexOf(source);
    $65fe2578b15097c5$export$d1d41f0cda037248.splice(index, 1);
}
function $65fe2578b15097c5$export$e2eaa0ea75f89eaa(gain) {
    return 20 * log10(gain);
    function log10(x) {
        return Math.log(x) / Math.LN10;
    }
}
function $65fe2578b15097c5$export$33ed28de027e9482(db) {
    return Math.pow(10, db / 20);
}







// Convert world direction to radians
function $4b341cc338785a8c$export$1ad3c7ead57ef8c(dir) {
    return dir * Math.PI / 180 - Math.PI / 2;
}
// Convert degrees to radians
function $4b341cc338785a8c$export$e6bfdeff8bfc94f9(deg) {
    return deg * Math.PI / 180;
}



const $169790e4820875e7$var$joystickEl = document.querySelector(".joystick");
const $169790e4820875e7$var$joystickSize = 60;
const $169790e4820875e7$export$d0b7ea69ab6056df = {
    active: false,
    startX: 0,
    startY: 0,
    xAxis: 0,
    yAxis: 0
};
function $169790e4820875e7$export$2cd8252107eb640b() {
    // Register touch events
    window.addEventListener("touchstart", (e)=>{
        $169790e4820875e7$export$d0b7ea69ab6056df.active = true;
        $169790e4820875e7$export$d0b7ea69ab6056df.startX = e.touches[0].clientX;
        $169790e4820875e7$export$d0b7ea69ab6056df.startY = e.touches[0].clientY;
        $169790e4820875e7$var$joystickEl.style.translate = `${$169790e4820875e7$export$d0b7ea69ab6056df.startX - $169790e4820875e7$var$joystickSize / 2}px ${$169790e4820875e7$export$d0b7ea69ab6056df.startY - $169790e4820875e7$var$joystickSize / 2}px`;
        $169790e4820875e7$var$joystickEl.style.opacity = 0.5;
    });
    window.addEventListener("touchmove", (e)=>{
        const halfJoy = $169790e4820875e7$var$joystickSize / 2;
        // Get touch move position
        let moveX = e.touches[0].clientX;
        let moveY = e.touches[0].clientY;
        // Calculate joystick delta
        let deltaX = moveX - $169790e4820875e7$export$d0b7ea69ab6056df.startX;
        let deltaY = moveY - $169790e4820875e7$export$d0b7ea69ab6056df.startY;
        // Calculate joystick distance
        const distance = Math.sqrt(deltaX ** 2 + deltaY ** 2);
        // Constrain joystick to its size
        if (distance > halfJoy) {
            const angle = Math.atan2(deltaY, deltaX);
            deltaX = Math.cos(angle) * halfJoy;
            deltaY = Math.sin(angle) * halfJoy;
            moveX = $169790e4820875e7$export$d0b7ea69ab6056df.startX + deltaX;
            moveY = $169790e4820875e7$export$d0b7ea69ab6056df.startY + deltaY;
        }
        $169790e4820875e7$export$d0b7ea69ab6056df.xAxis = deltaX / halfJoy;
        $169790e4820875e7$export$d0b7ea69ab6056df.yAxis = deltaY / halfJoy;
        // Update joystick position
        $169790e4820875e7$var$joystickEl.style.translate = `${moveX - halfJoy}px ${moveY - halfJoy}px`;
    });
    window.addEventListener("touchend", (e)=>{
        $169790e4820875e7$export$d0b7ea69ab6056df.active = false;
        $169790e4820875e7$var$joystickEl.style.opacity = 0;
    });
}



let $74f1281c4255ba38$export$9fddb9d0dd7d8a54 = 0; // Degrees with 0 facing north, -Y on canvas
const $74f1281c4255ba38$export$5880b8b5730aff45 = {
    x: 0,
    y: 0,
    z: 1.8
};
const $74f1281c4255ba38$export$e506a1d27d1eaa20 = {
    maxVelocity: 2.5,
    acceleration: 4,
    damping: 4,
    controllable: true
};
const $74f1281c4255ba38$var$velocity = {
    x: 0,
    y: 0,
    z: 0,
    magnitude: 0,
    direction: 0
};
let $74f1281c4255ba38$var$accelerateX, $74f1281c4255ba38$var$accelerateY;
let $74f1281c4255ba38$export$ed594bb491455ccb = false;
function $74f1281c4255ba38$export$722fbec263ad908a(dt) {
    $74f1281c4255ba38$var$accelerateX = 0;
    $74f1281c4255ba38$var$accelerateY = 0;
    if ($74f1281c4255ba38$export$e506a1d27d1eaa20.controllable) {
        // Update player direction (Arrow Keys)
        if ($4243735b17c41521$export$d081dc64f99d208b("ArrowLeft")) $74f1281c4255ba38$export$9fddb9d0dd7d8a54 -= 1;
        if ($4243735b17c41521$export$d081dc64f99d208b("ArrowRight")) $74f1281c4255ba38$export$9fddb9d0dd7d8a54 += 1;
        $74f1281c4255ba38$export$9fddb9d0dd7d8a54 %= 360;
        // Update player velocity (Arrow Keys)
        if ($4243735b17c41521$export$d081dc64f99d208b("ArrowUp")) $74f1281c4255ba38$var$accelerateY = -1;
        if ($4243735b17c41521$export$d081dc64f99d208b("ArrowDown")) $74f1281c4255ba38$var$accelerateY = 1;
        // Update player direction (Mouse Y)
        // TODO: Implement mouse movement
        // Update player velocity (WASD)
        if ($4243735b17c41521$export$d081dc64f99d208b("w")) $74f1281c4255ba38$var$accelerateY = -1;
        if ($4243735b17c41521$export$d081dc64f99d208b("a")) $74f1281c4255ba38$var$accelerateX = -1;
        if ($4243735b17c41521$export$d081dc64f99d208b("s")) $74f1281c4255ba38$var$accelerateY = 1;
        if ($4243735b17c41521$export$d081dc64f99d208b("d")) $74f1281c4255ba38$var$accelerateX = 1;
        // Update player direction (Gamepad)
        // TODO: Implement gamepad movement
        // Update player velocity and rotation (Touch)
        if ((0, $169790e4820875e7$export$d0b7ea69ab6056df).active) {
            $74f1281c4255ba38$var$accelerateY = (0, $169790e4820875e7$export$d0b7ea69ab6056df).yAxis;
            $74f1281c4255ba38$export$9fddb9d0dd7d8a54 += (0, $169790e4820875e7$export$d0b7ea69ab6056df).xAxis;
        }
    }
    $74f1281c4255ba38$var$applyAcceleration(dt);
    $74f1281c4255ba38$var$applyVelocity(dt);
    // Update audio listener position
    (0, $159fa085cd4c746e$export$f0551cbb67220cad)($74f1281c4255ba38$export$5880b8b5730aff45.x, $74f1281c4255ba38$export$5880b8b5730aff45.z, $74f1281c4255ba38$export$5880b8b5730aff45.y);
    // Update audio listener orientation
    (0, $159fa085cd4c746e$export$27298482267e128c)($74f1281c4255ba38$export$9fddb9d0dd7d8a54);
}
function $74f1281c4255ba38$var$applyAcceleration(dt) {
    const accelerationDirection = Math.atan2($74f1281c4255ba38$var$accelerateY, $74f1281c4255ba38$var$accelerateX) + (0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)($74f1281c4255ba38$export$9fddb9d0dd7d8a54);
    // Apply acceleration
    if ($74f1281c4255ba38$var$accelerateY || $74f1281c4255ba38$var$accelerateX) {
        $74f1281c4255ba38$var$velocity.x += Math.cos(accelerationDirection) * $74f1281c4255ba38$export$e506a1d27d1eaa20.acceleration * 2 * dt;
        $74f1281c4255ba38$var$velocity.y += Math.sin(accelerationDirection) * $74f1281c4255ba38$export$e506a1d27d1eaa20.acceleration * 2 * dt;
    }
}
function $74f1281c4255ba38$var$applyVelocity(dt) {
    // Calculate velocity magnitude
    $74f1281c4255ba38$var$velocity.magnitude = Math.sqrt($74f1281c4255ba38$var$velocity.x ** 2 + $74f1281c4255ba38$var$velocity.y ** 2);
    // Calculate velocity direction
    $74f1281c4255ba38$var$velocity.direction = Math.atan2($74f1281c4255ba38$var$velocity.y, $74f1281c4255ba38$var$velocity.x);
    // Limit velocity
    if ($74f1281c4255ba38$var$velocity.magnitude > $74f1281c4255ba38$export$e506a1d27d1eaa20.maxVelocity) {
        $74f1281c4255ba38$var$velocity.x = Math.cos($74f1281c4255ba38$var$velocity.direction) * $74f1281c4255ba38$export$e506a1d27d1eaa20.maxVelocity;
        $74f1281c4255ba38$var$velocity.y = Math.sin($74f1281c4255ba38$var$velocity.direction) * $74f1281c4255ba38$export$e506a1d27d1eaa20.maxVelocity;
        $74f1281c4255ba38$var$velocity.magnitude = $74f1281c4255ba38$export$e506a1d27d1eaa20.maxVelocity;
    }
    // Decelerate
    $74f1281c4255ba38$var$velocity.magnitude -= $74f1281c4255ba38$export$e506a1d27d1eaa20.damping * dt;
    if ($74f1281c4255ba38$var$velocity.magnitude < 0) $74f1281c4255ba38$var$velocity.magnitude = 0;
    $74f1281c4255ba38$var$velocity.x = Math.cos($74f1281c4255ba38$var$velocity.direction) * $74f1281c4255ba38$var$velocity.magnitude;
    $74f1281c4255ba38$var$velocity.y = Math.sin($74f1281c4255ba38$var$velocity.direction) * $74f1281c4255ba38$var$velocity.magnitude;
    // Add velocity to position
    $74f1281c4255ba38$export$5880b8b5730aff45.x += $74f1281c4255ba38$var$velocity.x * dt;
    $74f1281c4255ba38$export$5880b8b5730aff45.y += $74f1281c4255ba38$var$velocity.y * dt;
    $74f1281c4255ba38$export$5880b8b5730aff45.z += $74f1281c4255ba38$var$velocity.z * dt;
    // Constraint position to the worlds bounds
    const margin = 0.2;
    $74f1281c4255ba38$export$5880b8b5730aff45.x = Math.max($3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldBounds.left + margin, Math.min($74f1281c4255ba38$export$5880b8b5730aff45.x, $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldBounds.right - margin));
    $74f1281c4255ba38$export$5880b8b5730aff45.y = Math.max($3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldBounds.top + margin, Math.min($74f1281c4255ba38$export$5880b8b5730aff45.y, $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldBounds.bottom - margin));
    $74f1281c4255ba38$export$ed594bb491455ccb = $74f1281c4255ba38$export$5880b8b5730aff45.x === $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldBounds.left + margin || $74f1281c4255ba38$export$5880b8b5730aff45.x === $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldBounds.right - margin || $74f1281c4255ba38$export$5880b8b5730aff45.y === $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldBounds.top + margin || $74f1281c4255ba38$export$5880b8b5730aff45.y === $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldBounds.bottom - margin;
}
function $74f1281c4255ba38$export$e923c3a79e3a8606(dir) {
    $74f1281c4255ba38$export$9fddb9d0dd7d8a54 = dir;
}


const $f21970a667725935$var$tweens = [];
const $f21970a667725935$var$easingFunctions = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>t * (2 - t),
    easeInOutQuad: (t)=>t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t,
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>--t * t * t + 1,
    easeInOutCubic: (t)=>t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>1 - --t * t * t * t,
    easeInOutQuart: (t)=>t < .5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t,
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>1 + --t * t * t * t * t,
    easeInOutQuint: (t)=>t < .5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t
};
function $f21970a667725935$export$722fbec263ad908a(dt) {
    $f21970a667725935$var$tweens.forEach((tween)=>tween.update(dt));
}
class $f21970a667725935$export$208a41d6b4e37b97 {
    // TODO: return a promise that resolves when the tween ends ?
    constructor(from, to, duration, easingFunction = "linear", setFunction, callback){
        this.type = typeof from;
        if (this.type === "number") {
            this.from = from;
            this.to = to;
        } else if (this.type === "object") {
            this.target = from;
            this.from = {
                ...from
            };
            this.to = to;
        }
        this.duration = duration;
        this.time = 0;
        this.easingFunction = $f21970a667725935$var$easingFunctions[easingFunction];
        this.setFunction = setFunction;
        this.ended = false;
        this.callback = callback || this.dispose;
        $f21970a667725935$var$tweens.push(this);
    }
    update(dt) {
        this.time += dt;
        if (this.time > this.duration) {
            this.time = this.duration;
            if (typeof this.callback === "function" && !this.ended) this.callback(this);
            this.ended = true;
        }
        if (this.type === "object") for(const key in this.target)this.target[key] = $f21970a667725935$var$lerp(this.from[key], this.to[key], this.easingFunction(this.time / this.duration));
        if (this.setFunction) {
            if (this.type === "object") this.setFunction({
                ...this.target
            });
            else this.setFunction(this.value());
        }
    }
    value() {
        return $f21970a667725935$var$lerp(this.from, this.to, this.easingFunction(this.time / this.duration));
    }
    dispose() {
        $f21970a667725935$var$tweens.splice($f21970a667725935$var$tweens.indexOf(this), 1);
    }
}
function $f21970a667725935$var$lerp(from, to, t) {
    return from + (to - from) * t;
}



const $9e3987a94d403814$var$soundAssets = [];
const $9e3987a94d403814$var$imageAssets = [];
const $9e3987a94d403814$export$6c746a5570b8b35c = {};
function $9e3987a94d403814$export$2cd8252107eb640b() {
    return Promise.all([
        $9e3987a94d403814$var$loadSounds(),
        $9e3987a94d403814$var$loadImages()
    ]);
}
function $9e3987a94d403814$export$cb43b96ee3d96841(sounds) {
    $9e3987a94d403814$var$soundAssets.push(...sounds);
}
function $9e3987a94d403814$export$8250d5b41185d62d(images) {
    $9e3987a94d403814$var$imageAssets.push(...images);
}
var $3e7c2d44fb27faf3$exports = {};

$3e7c2d44fb27faf3$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../bruit-de-fond.3bb7df54.wav";


function $9e3987a94d403814$var$loadSounds() {
    return Promise.all([
        ...$9e3987a94d403814$var$soundAssets.map((sound)=>{
            return $cdce0d2b992d5ef2$exports.load(sound.name, sound.url);
        }),
        $cdce0d2b992d5ef2$exports.load("bruit-de-fond", new URL($3e7c2d44fb27faf3$exports))
    ]).then(()=>{
        if (DEVMODE) console.log(`${$9e3987a94d403814$var$soundAssets.length} sounds loaded`);
    });
}
function $9e3987a94d403814$var$loadImages() {
    return Promise.all([
        ...$9e3987a94d403814$var$imageAssets.map((image)=>{
            return new Promise((resolve, reject)=>{
                const img = new Image();
                img.onload = ()=>{
                    if (DEVMODE) console.log(`Image ${image.name} loaded`);
                    resolve();
                };
                img.onerror = ()=>{
                    reject(`Error loading image ${image.name}`);
                };
                img.src = image.url;
                $9e3987a94d403814$export$6c746a5570b8b35c[image.name] = img;
                $9e3987a94d403814$export$6c746a5570b8b35c[image.name].ppm = image.ppm;
            });
        })
    ]).then(()=>{
        if (DEVMODE) console.log(`${$9e3987a94d403814$var$imageAssets.length} images loaded`);
    });
}








const $71fd8a9a49abf6a2$var$POIs = [
    {
        name: "stonehenge-center",
        position: {
            x: 0,
            y: 0,
            z: 0
        },
        color: "hsl(0, 0%, 20%)",
        radius: 20,
        style: "idle",
        symbolic: false,
        collision: {
            radius: 1
        },
        onEnter () {
            if (this.style === "idle") return;
            $65fe2578b15097c5$export$51b36263b660c3ee(); // TODO: This will not stop Grudge's whistles and will prevent restarting the game
            $cdce0d2b992d5ef2$exports.play("ding-final", {
                gain: 0
            });
            $74f1281c4255ba38$export$e506a1d27d1eaa20.controllable = false;
            new (0, $f21970a667725935$export$208a41d6b4e37b97)($74f1281c4255ba38$export$5880b8b5730aff45, this.position, 2, "easeOutQuad");
            new (0, $f21970a667725935$export$208a41d6b4e37b97)($74f1281c4255ba38$export$9fddb9d0dd7d8a54, 0, 2, "easeOutQuad", (v)=>{
                $74f1281c4255ba38$export$e923c3a79e3a8606(v);
            });
            setTimeout(()=>{
                $cdce0d2b992d5ef2$exports.play("labyrinthe-des-echos", {
                    gain: 0
                });
            }, 2000);
            setTimeout(()=>{
                $41cc4e3e034c1d5f$export$787f5d117f138d13(`
                    Cet \xe9pisode exp\xe9rience a \xe9t\xe9 cr\xe9\xe9e dans les locaux d\u{2019}INIZIO,<br>
                    \xe0 Vevey (CH) du 11 au 15 mars 2024 avec la participation de :<br>
                    <br>
                    Brendan, Charline, Dragos, Daniel, Daniel,<br>
                    Eline, Justin, Jonas, Laura, Leo,<br>
                    Lo\xefc, Mateo, Mauro, Nicolas, Purdey,<br>
                    Stefanie, et Willow<br>
                    <br>
                    <a href="https://low-project.ch/">low-project.ch</a><br>
                    <a href="https://inizio-vd.ch/">inizio-vd.ch</a>
                `.trim(), "Fin");
            }, 10000);
        }
    },
    {
        name: "stonehenge-triangle-1",
        position: {
            x: 0,
            y: -2,
            z: 1.8
        },
        color: "hsl(0, 100%, 50%)",
        type: "triangle",
        radius: 7.5,
        symbolic: false,
        style: "idle",
        rotation: 180,
        collision: {
            radius: 0.5
        },
        onEnter () {
            if (this.style === "active") $cdce0d2b992d5ef2$exports.play("Flash_maraisOut", {
                gain: 0
            });
        }
    },
    {
        name: "stonehenge-triangle-2",
        position: {
            x: 1.41,
            y: -1.41,
            z: 1.8
        },
        color: "hsl(45, 100%, 50%)",
        type: "triangle",
        radius: 7.5,
        symbolic: false,
        style: "idle",
        rotation: 225,
        collision: {
            radius: 0.5
        },
        onEnter () {
            if (this.style === "active") $cdce0d2b992d5ef2$exports.play("Flash_machine", {
                gain: 0
            });
        }
    },
    {
        name: "stonehenge-triangle-3",
        position: {
            x: 2,
            y: 0,
            z: 1.8
        },
        color: "hsl(90, 100%, 50%)",
        type: "triangle",
        radius: 7.5,
        symbolic: false,
        style: "idle",
        rotation: 270,
        collision: {
            radius: 0.5
        },
        onEnter () {
            if (this.style === "active") $cdce0d2b992d5ef2$exports.play("Flash_Moskito", {
                gain: 0
            });
        }
    },
    {
        name: "stonehenge-triangle-4",
        position: {
            x: 1.41,
            y: 1.41,
            z: 1.8
        },
        color: "hsl(135, 100%, 50%)",
        type: "triangle",
        radius: 7.5,
        symbolic: false,
        style: "idle",
        rotation: 315,
        collision: {
            radius: 0.5
        },
        onEnter () {
            if (this.style === "active") $cdce0d2b992d5ef2$exports.play("Flash_Hey", {
                gain: 0
            });
        }
    },
    {
        name: "stonehenge-triangle-5",
        position: {
            x: 0,
            y: 2,
            z: 1.8
        },
        color: "hsl(180, 100%, 50%)",
        type: "triangle",
        radius: 7.5,
        symbolic: false,
        style: "idle",
        rotation: 0,
        collision: {
            radius: 0.5
        },
        onEnter () {
            if (this.style === "active") $cdce0d2b992d5ef2$exports.play("Flash_Inspir", {
                gain: 0
            });
        }
    },
    {
        name: "stonehenge-triangle-6",
        position: {
            x: -1.41,
            y: 1.41,
            z: 1.8
        },
        color: "hsl(225, 100%, 50%)",
        type: "triangle",
        radius: 7.5,
        symbolic: false,
        style: "idle",
        rotation: 45,
        collision: {
            radius: 0.5
        },
        onEnter () {
            if (this.style === "active") $cdce0d2b992d5ef2$exports.play("Flash_chuchot", {
                gain: 0
            });
        }
    },
    {
        name: "stonehenge-triangle-7",
        position: {
            x: -2,
            y: 0,
            z: 1.8
        },
        color: "hsl(270, 100%, 50%)",
        type: "triangle",
        radius: 7.5,
        symbolic: false,
        style: "idle",
        rotation: 90,
        collision: {
            radius: 0.5
        },
        onEnter () {
            if (this.style === "active") $cdce0d2b992d5ef2$exports.play("Flash_Melopee", {
                gain: 0
            });
        }
    },
    {
        name: "stonehenge-triangle-8",
        position: {
            x: -1.41,
            y: -1.41,
            z: 1.8
        },
        color: "hsl(315, 100%, 50%)",
        type: "triangle",
        radius: 7.5,
        symbolic: false,
        style: "idle",
        rotation: 135,
        collision: {
            radius: 0.5
        },
        onEnter () {
            if (this.style === "active") $cdce0d2b992d5ef2$exports.play("Flash_grudge", {
                gain: 0
            });
        }
    }
];
var $7498332bb13df25c$exports = {};

$7498332bb13df25c$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../DingCle.8fd7974a.wav";


var $51940ae59f3f474c$exports = {};

$51940ae59f3f474c$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../DingCle2.b55dac96.wav";


var $68b4124becb5f1a4$exports = {};

$68b4124becb5f1a4$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Flash_chuchot.11008de8.wav";


var $49c63a9c21531152$exports = {};

$49c63a9c21531152$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Flash_grudge.cfb47c06.wav";


var $548154cef0628d26$exports = {};

$548154cef0628d26$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Flash_Hey.0ec3308f.wav";


var $6a6f00337646682f$exports = {};

$6a6f00337646682f$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Flash_Inspir.407d2023.wav";


var $5ec6ea2bab2bbf25$exports = {};

$5ec6ea2bab2bbf25$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Flash_machine.321fef68.wav";


var $5a53aabf8bca386f$exports = {};

$5a53aabf8bca386f$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Flash_MaraisOut.834e10a8.wav";


var $b03fce2bb01755d9$exports = {};

$b03fce2bb01755d9$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Flash_Melopee.5a42748f.wav";


var $9e5f8c58c90b51fa$exports = {};

$9e5f8c58c90b51fa$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Flash_Moskito.d4a96086.wav";


const $71fd8a9a49abf6a2$var$sounds = [
    {
        name: "ding",
        url: new URL($7498332bb13df25c$exports)
    },
    {
        name: "ding2",
        url: new URL($51940ae59f3f474c$exports)
    },
    {
        name: "Flash_chuchot",
        url: new URL($68b4124becb5f1a4$exports)
    },
    {
        name: "Flash_grudge",
        url: new URL($49c63a9c21531152$exports)
    },
    {
        name: "Flash_Hey",
        url: new URL($548154cef0628d26$exports)
    },
    {
        name: "Flash_Inspir",
        url: new URL($6a6f00337646682f$exports)
    },
    {
        name: "Flash_machine",
        url: new URL($5ec6ea2bab2bbf25$exports)
    },
    {
        name: "Flash_maraisOut",
        url: new URL($5a53aabf8bca386f$exports)
    },
    {
        name: "Flash_Melopee",
        url: new URL($b03fce2bb01755d9$exports)
    },
    {
        name: "Flash_Moskito",
        url: new URL($9e5f8c58c90b51fa$exports)
    }
];
const $71fd8a9a49abf6a2$var$images = [];
function $71fd8a9a49abf6a2$export$2cd8252107eb640b() {
    $3d5a7a21f49e3736$export$1d3a1dba469744a6($71fd8a9a49abf6a2$var$POIs);
    //loader.addImages(images);
    $9e3987a94d403814$export$cb43b96ee3d96841($71fd8a9a49abf6a2$var$sounds);
}







const $ee5ccea06a0bc267$var$POIs = [
    {
        name: "demo-rouge",
        position: {
            x: -8,
            y: -8,
            z: 3
        },
        color: "red",
        radius: 5,
        sound: {
            name: "grains_pluie",
            gain: 0
        },
        collision: {
            radius: 1
        },
        onEnter () {
            // Follow player
            const originalPosition = {
                ...this.position
            };
            new (0, $f21970a667725935$export$208a41d6b4e37b97)(this.position, $74f1281c4255ba38$export$5880b8b5730aff45, 1, "easeOutQuad", (v)=>{
                this.sound.panner.positionPanner(v.x, v.z, v.y);
            }, (tween)=>{
                setTimeout(()=>{
                    // Manual cleanup to stop following player
                    tween.dispose();
                    new (0, $f21970a667725935$export$208a41d6b4e37b97)(this.position, originalPosition, 4, "easeInOutQuad", (v)=>{
                        this.sound.panner.positionPanner(v.x, v.z, v.y);
                    });
                    new (0, $f21970a667725935$export$208a41d6b4e37b97)(12, 5, 2, "easeOutQuad", (v)=>{
                        this.radius = v;
                    });
                }, 10000);
            });
            // Increase radius to 15
            new (0, $f21970a667725935$export$208a41d6b4e37b97)(this.radius, 12, 0.5, "easeOutQuad", (v)=>{
                this.radius = v;
            });
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "demo-bleu",
        position: {
            x: 8,
            y: -8,
            z: 0.2
        },
        color: "blue",
        sound: {
            name: "hydro",
            gain: 0
        },
        collision: {
            radius: 1
        },
        onEnter () {
            this.sound.source.fadeTo(2, -90, 0);
        },
        onLeave () {
            this.sound.source.fadeTo(2, 0, -90);
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "demo-vert",
        position: {
            x: 8,
            y: 8,
            z: 0.5
        },
        color: "green",
        radius: 15,
        sound: {
            name: "metal-guitar",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "demo-jaune",
        position: {
            x: -8,
            y: 8,
            z: 1.8
        },
        color: "yellow",
        sound: {
            name: "histoire",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    }
];
var $fb6ad16f47a357d1$exports = {};

$fb6ad16f47a357d1$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../grains_pluie.4b748a48.wav";


var $9ab879debbcb5593$exports = {};

$9ab879debbcb5593$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../hydro.ba223b40.wav";


var $0162a538c7778988$exports = {};

$0162a538c7778988$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../histoire.f1f2b6d5.wav";


var $c1a78788a3277f6e$exports = {};

$c1a78788a3277f6e$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../metal-guitar.2c0b3812.wav";


const $ee5ccea06a0bc267$var$sounds = [
    {
        name: "grains_pluie",
        url: new URL($fb6ad16f47a357d1$exports)
    },
    {
        name: "hydro",
        url: new URL($9ab879debbcb5593$exports)
    },
    {
        name: "histoire",
        url: new URL($0162a538c7778988$exports)
    },
    {
        name: "metal-guitar",
        url: new URL($c1a78788a3277f6e$exports)
    }
];
const $ee5ccea06a0bc267$var$images = [];
function $ee5ccea06a0bc267$export$2cd8252107eb640b() {
    $3d5a7a21f49e3736$export$1d3a1dba469744a6($ee5ccea06a0bc267$var$POIs);
    $9e3987a94d403814$export$8250d5b41185d62d($ee5ccea06a0bc267$var$images);
    $9e3987a94d403814$export$cb43b96ee3d96841($ee5ccea06a0bc267$var$sounds);
}











let $ddc63e08d7bd2fae$export$39f92e86d1722f3a;
function $ddc63e08d7bd2fae$export$2cd8252107eb640b() {
    const canvas = document.querySelector("canvas");
    $ddc63e08d7bd2fae$export$39f92e86d1722f3a = canvas.getContext("2d");
    canvas.width = (0, $a17d6d7671adcc59$export$e506a1d27d1eaa20).width * devicePixelRatio;
    canvas.height = (0, $a17d6d7671adcc59$export$e506a1d27d1eaa20).height * devicePixelRatio;
    $ddc63e08d7bd2fae$export$39f92e86d1722f3a.scale(devicePixelRatio, devicePixelRatio);
    if (DEVMODE) console.log(`Canvas initialized with DPR: ${devicePixelRatio} Size: ${canvas.width}/${canvas.height}`);
}
function $ddc63e08d7bd2fae$export$42ffd38884aecdac() {
    $ddc63e08d7bd2fae$export$39f92e86d1722f3a.clearRect(0, 0, (0, $a17d6d7671adcc59$export$e506a1d27d1eaa20).width, (0, $a17d6d7671adcc59$export$e506a1d27d1eaa20).height);
}






// Config
const $ccec0efdcdb6886e$export$e506a1d27d1eaa20 = {
    compassRadius: 150,
    maxCompassRadius: 150,
    pixelsPerMeter: 25,
    pointSeparation: 1
};
let $ccec0efdcdb6886e$var$trackPlayer = true;
const $ccec0efdcdb6886e$var$rotateWhileZooming = false;
const $ccec0efdcdb6886e$export$3d9982e937097c50 = {
    x: 0,
    y: 0
};
let $ccec0efdcdb6886e$var$cameraDirection = 0;
let $ccec0efdcdb6886e$var$mode = "heading-up"; // 'north-up' or 'heading-up'
let $ccec0efdcdb6886e$var$pointsInterval, $ccec0efdcdb6886e$var$offscreenCanvas;
let $ccec0efdcdb6886e$var$playerColor = "white";
function $ccec0efdcdb6886e$export$2cd8252107eb640b() {
    $ccec0efdcdb6886e$var$pointsInterval = $ccec0efdcdb6886e$export$e506a1d27d1eaa20.pointSeparation * $ccec0efdcdb6886e$export$e506a1d27d1eaa20.pixelsPerMeter;
    $ccec0efdcdb6886e$var$offscreenCanvas = new OffscreenCanvas((2 * $ccec0efdcdb6886e$export$e506a1d27d1eaa20.maxCompassRadius + $ccec0efdcdb6886e$var$pointsInterval * 2) * devicePixelRatio, (2 * $ccec0efdcdb6886e$export$e506a1d27d1eaa20.maxCompassRadius + $ccec0efdcdb6886e$var$pointsInterval * 2) * devicePixelRatio);
    $ccec0efdcdb6886e$var$preparePointFieldImage();
// Example for changing playerColor every 500ms
// setInterval(() => {
//     playerColor = `hsl(${Math.random()*360}, 100%, 50%)`;
// }, 500);
}
function $ccec0efdcdb6886e$export$722fbec263ad908a() {
    if ($ccec0efdcdb6886e$var$trackPlayer) {
        $ccec0efdcdb6886e$export$3d9982e937097c50.x = $74f1281c4255ba38$export$5880b8b5730aff45.x;
        $ccec0efdcdb6886e$export$3d9982e937097c50.y = $74f1281c4255ba38$export$5880b8b5730aff45.y;
        $ccec0efdcdb6886e$var$cameraDirection = $74f1281c4255ba38$export$9fddb9d0dd7d8a54;
    }
}
function $ccec0efdcdb6886e$export$e529deb2bfd496dc() {
    // Example of a dynamic compass radius
    // config.compassRadius = 100 + Math.sin(Math.floor(Date.now() / 5 % 1000) / 1000 * Math.PI * 2) * 50;
    // Create clip path (same as compass outline)
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).beginPath();
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).arc($a17d6d7671adcc59$export$e506a1d27d1eaa20.width / 2, $a17d6d7671adcc59$export$e506a1d27d1eaa20.height / 2, $ccec0efdcdb6886e$export$e506a1d27d1eaa20.compassRadius, 0, Math.PI * 2);
    // Clip further draws to compass outline
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).save();
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).clip();
    $ccec0efdcdb6886e$var$drawWorld();
    // Restore pre-clip
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).restore();
    $ccec0efdcdb6886e$var$drawCompass();
}
function $ccec0efdcdb6886e$var$drawWorld() {
    // Add translate and rotate to the transformation matrix for world coordinates
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).save();
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).translate($a17d6d7671adcc59$export$e506a1d27d1eaa20.width / 2, $a17d6d7671adcc59$export$e506a1d27d1eaa20.height / 2);
    if ($ccec0efdcdb6886e$var$mode === "heading-up") (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).rotate((0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(-$ccec0efdcdb6886e$var$cameraDirection));
    // Draw point field
    $ccec0efdcdb6886e$var$drawPointField();
    // Draw world bounds
    $ccec0efdcdb6886e$var$drawWorldBounds();
    // Draw entities
    $ccec0efdcdb6886e$var$drawPOIs();
    $ccec0efdcdb6886e$var$drawPlayer();
    // Restore transformation matrix to canvas coordinates
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).restore();
}
function $ccec0efdcdb6886e$var$drawCompass() {
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fillStyle = "white";
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).strokeStyle = "white";
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).lineWidth = 1;
    // Draw compass directions
    $ccec0efdcdb6886e$var$drawCompassDirection(0, "N");
    $ccec0efdcdb6886e$var$drawCompassDirection(90, "E");
    $ccec0efdcdb6886e$var$drawCompassDirection(180, "S");
    $ccec0efdcdb6886e$var$drawCompassDirection(270, "O");
    // Draw compass outline
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).beginPath();
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).arc($a17d6d7671adcc59$export$e506a1d27d1eaa20.width / 2, $a17d6d7671adcc59$export$e506a1d27d1eaa20.height / 2, $ccec0efdcdb6886e$export$e506a1d27d1eaa20.compassRadius, 0, Math.PI * 2);
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).stroke();
}
function $ccec0efdcdb6886e$var$drawWorldBounds() {
    const cameraPos = $ccec0efdcdb6886e$var$worldToCanvas($ccec0efdcdb6886e$export$3d9982e937097c50);
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).strokeStyle = "white";
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).lineWidth = 1;
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).beginPath();
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).moveTo($3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldBounds.left * $ccec0efdcdb6886e$export$e506a1d27d1eaa20.pixelsPerMeter - cameraPos.x, $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldBounds.top * $ccec0efdcdb6886e$export$e506a1d27d1eaa20.pixelsPerMeter - cameraPos.y);
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).lineTo($3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldBounds.right * $ccec0efdcdb6886e$export$e506a1d27d1eaa20.pixelsPerMeter - cameraPos.x, $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldBounds.top * $ccec0efdcdb6886e$export$e506a1d27d1eaa20.pixelsPerMeter - cameraPos.y);
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).lineTo($3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldBounds.right * $ccec0efdcdb6886e$export$e506a1d27d1eaa20.pixelsPerMeter - cameraPos.x, $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldBounds.bottom * $ccec0efdcdb6886e$export$e506a1d27d1eaa20.pixelsPerMeter - cameraPos.y);
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).lineTo($3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldBounds.left * $ccec0efdcdb6886e$export$e506a1d27d1eaa20.pixelsPerMeter - cameraPos.x, $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldBounds.bottom * $ccec0efdcdb6886e$export$e506a1d27d1eaa20.pixelsPerMeter - cameraPos.y);
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).closePath();
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).stroke();
}
function $ccec0efdcdb6886e$var$drawPlayer() {
    const cameraPos = $ccec0efdcdb6886e$var$worldToCanvas($ccec0efdcdb6886e$export$3d9982e937097c50);
    const playerPos = $ccec0efdcdb6886e$var$worldToCanvas($74f1281c4255ba38$export$5880b8b5730aff45);
    // Add translate and rotate to the transformation matrix for world coordinates
    // TODO: convert all other draws with initial transforms then local coordinates like this method
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).save();
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).translate(playerPos.x - cameraPos.x, playerPos.y - cameraPos.y);
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).rotate((0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)($74f1281c4255ba38$export$9fddb9d0dd7d8a54));
    // Draw player
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).beginPath();
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).arc(0, 12, 8, (0, $4b341cc338785a8c$export$1ad3c7ead57ef8c)(0) - (0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(45), (0, $4b341cc338785a8c$export$1ad3c7ead57ef8c)(0) + (0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(45));
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).lineTo(0, -8);
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).closePath();
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fillStyle = $ccec0efdcdb6886e$var$playerColor;
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fill();
    // Restore transformation matrix to canvas coordinates
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).restore();
}
function $ccec0efdcdb6886e$var$drawCompassDirection(dir, txt) {
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fillStyle = "white";
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).strokeStyle = "white";
    // Add player direction
    const angle = $ccec0efdcdb6886e$var$mode === "heading-up" ? dir - $ccec0efdcdb6886e$var$cameraDirection : dir;
    // Draw direction triangle
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).beginPath();
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).arc($a17d6d7671adcc59$export$e506a1d27d1eaa20.width / 2, $a17d6d7671adcc59$export$e506a1d27d1eaa20.height / 2, $ccec0efdcdb6886e$export$e506a1d27d1eaa20.compassRadius, (0, $4b341cc338785a8c$export$1ad3c7ead57ef8c)(angle) - (0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(8), (0, $4b341cc338785a8c$export$1ad3c7ead57ef8c)(angle) + (0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(8));
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).lineTo($a17d6d7671adcc59$export$e506a1d27d1eaa20.width / 2 + Math.sin((0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(angle)) * ($ccec0efdcdb6886e$export$e506a1d27d1eaa20.compassRadius + 20), $a17d6d7671adcc59$export$e506a1d27d1eaa20.height / 2 - Math.cos((0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(angle)) * ($ccec0efdcdb6886e$export$e506a1d27d1eaa20.compassRadius + 20));
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).lineTo($a17d6d7671adcc59$export$e506a1d27d1eaa20.width / 2 + Math.sin((0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(angle) - (0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(8)) * $ccec0efdcdb6886e$export$e506a1d27d1eaa20.compassRadius, $a17d6d7671adcc59$export$e506a1d27d1eaa20.height / 2 - Math.cos((0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(angle) - (0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(8)) * $ccec0efdcdb6886e$export$e506a1d27d1eaa20.compassRadius);
    // Only North is filled
    if (dir === 0) {
        (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fill();
        (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fillStyle = "black";
    } else (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).stroke();
    // Draw text
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).font = "10px Helvetica Neue";
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fillText(txt, $a17d6d7671adcc59$export$e506a1d27d1eaa20.width / 2 + Math.sin((0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(angle)) * ($ccec0efdcdb6886e$export$e506a1d27d1eaa20.compassRadius + 7) - 3.5, $a17d6d7671adcc59$export$e506a1d27d1eaa20.height / 2 - Math.cos((0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(angle)) * ($ccec0efdcdb6886e$export$e506a1d27d1eaa20.compassRadius + 7) + 3.5);
}
function $ccec0efdcdb6886e$var$preparePointFieldImage() {
    const offctx = $ccec0efdcdb6886e$var$offscreenCanvas.getContext("2d");
    offctx.clearRect(0, 0, $ccec0efdcdb6886e$var$offscreenCanvas.width, $ccec0efdcdb6886e$var$offscreenCanvas.height);
    offctx.fillStyle = "#444";
    for(let x = 0; x <= $ccec0efdcdb6886e$var$offscreenCanvas.width; x += $ccec0efdcdb6886e$var$pointsInterval)for(let y = 0; y <= $ccec0efdcdb6886e$var$offscreenCanvas.height; y += $ccec0efdcdb6886e$var$pointsInterval){
        offctx.beginPath();
        offctx.arc(x, y, 2, 0, Math.PI * 2);
        offctx.fill();
    }
}
function $ccec0efdcdb6886e$var$drawPointField() {
    const cameraPos = $ccec0efdcdb6886e$var$worldToCanvas($ccec0efdcdb6886e$export$3d9982e937097c50);
    const offsetX = cameraPos.x % $ccec0efdcdb6886e$var$pointsInterval;
    const offsetY = cameraPos.y % $ccec0efdcdb6886e$var$pointsInterval;
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).drawImage($ccec0efdcdb6886e$var$offscreenCanvas, -$ccec0efdcdb6886e$export$e506a1d27d1eaa20.maxCompassRadius - $ccec0efdcdb6886e$var$pointsInterval - offsetX, -$ccec0efdcdb6886e$export$e506a1d27d1eaa20.maxCompassRadius - $ccec0efdcdb6886e$var$pointsInterval - offsetY);
}
function $ccec0efdcdb6886e$var$drawPOIs() {
    // TODO: filter out POIs that are outside the compass radius
    const visiblePOIs = $3d5a7a21f49e3736$export$8061040b42890c32.filter((p)=>!p.invisible);
    for (const p of visiblePOIs){
        const cameraPos = $ccec0efdcdb6886e$var$worldToCanvas($ccec0efdcdb6886e$export$3d9982e937097c50);
        const poiPos = $ccec0efdcdb6886e$var$worldToCanvas(p.position);
        (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fillStyle = p.color;
        (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).beginPath();
        if (p.image) {
            // Draw image
            const imageWidth = $9e3987a94d403814$export$6c746a5570b8b35c[p.image].width / $9e3987a94d403814$export$6c746a5570b8b35c[p.image].ppm * $ccec0efdcdb6886e$export$e506a1d27d1eaa20.pixelsPerMeter;
            const imageHeight = $9e3987a94d403814$export$6c746a5570b8b35c[p.image].height / $9e3987a94d403814$export$6c746a5570b8b35c[p.image].ppm * $ccec0efdcdb6886e$export$e506a1d27d1eaa20.pixelsPerMeter;
            (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).drawImage($9e3987a94d403814$export$6c746a5570b8b35c[p.image], poiPos.x - cameraPos.x - imageWidth / 2, poiPos.y - cameraPos.y - imageHeight / 2, // Convention: images are sized at 25 pixels per meter
            imageWidth, imageHeight);
        } else if (p.type === "triangle") {
            // Draw a triangle centered on p.position
            (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).save();
            (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).translate(poiPos.x - cameraPos.x, poiPos.y - cameraPos.y);
            (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).rotate((0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(p.rotation));
            (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).beginPath();
            (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).moveTo(Math.cos((0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(150)) * p.radius, Math.sin((0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(150)) * p.radius);
            (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).lineTo(0, -p.radius);
            (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).lineTo(Math.cos((0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(30)) * p.radius, Math.sin((0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(30)) * p.radius);
            (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).closePath();
            (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).restore();
        } else if (p.type === "circle" || !p.type) // Draw circle (default type)
        (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).arc(poiPos.x - cameraPos.x, poiPos.y - cameraPos.y, p.radius || 5, 0, Math.PI * 2);
        // Handling for styled shapes
        if (!p.image) {
            if (!p.style) (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fill();
            else if (p.style === "idle") {
                (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fillStyle = "#223";
                (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).strokeStyle = "#99b";
                (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).lineWidth = 1;
                (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fill();
                (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).stroke();
            } else if (p.style === "active") {
                const timebase = Math.abs(Math.sin(Math.floor(Date.now() / 3 % 1000) / 1000 * Math.PI * 2));
                (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).strokeStyle = p.color.replace("50%", `${timebase * 40 + 50}%`);
                (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).lineWidth = 2;
                (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fill();
                (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).stroke();
            } else if (p.style === "complete") {
                const timebase = Math.floor(Date.now() % 2000) / 2000;
                (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fillStyle = `hsl(${timebase * 360}, 50%, 30%)`;
                (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).strokeStyle = `hsl(${timebase * 360}, 100%, 50%)`;
                (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).lineWidth = 2;
                (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fill();
                (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).stroke();
            }
        }
    }
}
function $ccec0efdcdb6886e$export$1fc0f6205829e19c() {
    return $ccec0efdcdb6886e$var$mode;
}
function $ccec0efdcdb6886e$export$ba03f2a005091f3b() {
    $ccec0efdcdb6886e$var$mode = $ccec0efdcdb6886e$var$mode === "heading-up" ? "north-up" : "heading-up";
}
function $ccec0efdcdb6886e$export$bdcc994deaedab19() {
    $ccec0efdcdb6886e$var$trackPlayer = false;
    new (0, $f21970a667725935$export$208a41d6b4e37b97)($ccec0efdcdb6886e$export$3d9982e937097c50, {
        x: 0,
        y: 0
    }, 2, "easeInOutQuad");
    if ($ccec0efdcdb6886e$var$rotateWhileZooming) new (0, $f21970a667725935$export$208a41d6b4e37b97)($ccec0efdcdb6886e$var$cameraDirection, 0, 2, "easeInOutQuad", (v)=>{
        $ccec0efdcdb6886e$var$cameraDirection = v;
    });
}
function $ccec0efdcdb6886e$export$a66bf038d7620ad7() {
    new (0, $f21970a667725935$export$208a41d6b4e37b97)($ccec0efdcdb6886e$export$3d9982e937097c50, $74f1281c4255ba38$export$5880b8b5730aff45, 2, "easeInOutQuad", null, (tween)=>{
        $ccec0efdcdb6886e$var$trackPlayer = true;
        tween.dispose();
    });
    if ($ccec0efdcdb6886e$var$rotateWhileZooming) new (0, $f21970a667725935$export$208a41d6b4e37b97)(0, $74f1281c4255ba38$export$9fddb9d0dd7d8a54, 2, "easeInOutQuad", (v)=>{
        $ccec0efdcdb6886e$var$cameraDirection = v;
    });
}
// Convert world coordinates to canvas coordinates
// TODO: If this function serves only as a pixel-per-meter conversion, it should probably be deleted
function $ccec0efdcdb6886e$var$worldToCanvas(vector) {
    return {
        x: vector.x * $ccec0efdcdb6886e$export$e506a1d27d1eaa20.pixelsPerMeter,
        y: vector.y * $ccec0efdcdb6886e$export$e506a1d27d1eaa20.pixelsPerMeter
    };
}



const $c2fc41d0cd52f73e$var$queuedTriangles = [];
function $c2fc41d0cd52f73e$export$2cd8252107eb640b() {}
function $c2fc41d0cd52f73e$var$isCollected(name) {
    return $3d5a7a21f49e3736$export$8061040b42890c32.find((p)=>p.name === name).style === "active";
}
function $c2fc41d0cd52f73e$export$663103110d94aac9(name, position, options) {
    /*
        Options:
        - color
        - gain (dB)
        - collisionRadius (m)
        - offset {x, y} (m)
        - delay (s)
        - despawn (s)
    */ const pos = {
        x: position.x + (options.offset?.x || 0),
        y: position.y + (options.offset?.y || 0),
        z: 0
    };
    // Prevent dropping a collectible if its center sibling is already activated
    if ($c2fc41d0cd52f73e$var$isCollected(name)) return;
    // Prevent dropping a collectible triangle again if its waiting for a timeout
    if ($c2fc41d0cd52f73e$var$queuedTriangles.includes(`${name}-collectible`)) return;
    // Prevent dropping a collectible if it already exists
    if ($3d5a7a21f49e3736$export$8061040b42890c32.find((p)=>p.name === `${name}-collectible`)) return;
    const centerTriangle = $3d5a7a21f49e3736$export$8061040b42890c32.find((p)=>p.name === name);
    // Drop a triangle at the given position
    const triangle = {
        name: `${name}-collectible`,
        position: pos,
        color: options.color || centerTriangle.color || "hsl(0, 100%, 50%)",
        type: "triangle",
        radius: 7.5,
        hideOnMap: true,
        collision: {
            radius: options.collisionRadius || 1
        },
        onEnter () {
            // Remove the triangle from the scene with splice
            const index = $3d5a7a21f49e3736$export$8061040b42890c32.indexOf(this);
            $3d5a7a21f49e3736$export$8061040b42890c32.splice(index, 1);
            $cdce0d2b992d5ef2$exports.play("ding", {
                gain: options.gain || 0
            });
            // Prevent the player from moving
            $74f1281c4255ba38$export$e506a1d27d1eaa20.controllable = false;
            // Zoom to the origin
            $ccec0efdcdb6886e$export$bdcc994deaedab19();
            setTimeout(()=>{
                $c2fc41d0cd52f73e$export$2dabce2e5d7031d0(name, options.gain || 0);
            }, 3000);
        }
    };
    const panner = (0, $159fa085cd4c746e$export$604289ae06b8fa82)();
    panner.positionPanner(pos.x, pos.z, pos.y); // TODO: just pass pos !
    // Drop triangle after a few seconds
    setTimeout(()=>{
        $cdce0d2b992d5ef2$exports.play("ding-pop", {
            destination: panner,
            gain: options.gain || 0
        });
        $3d5a7a21f49e3736$export$8061040b42890c32.push(triangle);
        $c2fc41d0cd52f73e$var$queuedTriangles.splice($c2fc41d0cd52f73e$var$queuedTriangles.indexOf(triangle.name), 1);
    }, options.delay * 1000 || 0);
    if (options.despawn) setTimeout(()=>{
        const index = $3d5a7a21f49e3736$export$8061040b42890c32.indexOf(triangle);
        if (index) $3d5a7a21f49e3736$export$8061040b42890c32.splice(index, 1);
    }, options.despawn * 1000);
    $c2fc41d0cd52f73e$var$queuedTriangles.push(triangle.name);
}
function $c2fc41d0cd52f73e$export$364cd37066d27690() {
    // Check if all collectible triangles have been picked
    const activeStonehengeTriangles = $3d5a7a21f49e3736$export$8061040b42890c32.filter((p)=>{
        return p.name.includes("stonehenge-triangle") && p.style === "active";
    });
    return activeStonehengeTriangles.length === 8;
}
function $c2fc41d0cd52f73e$export$2dabce2e5d7031d0(name, gain = 0, zoomBack = true) {
    $cdce0d2b992d5ef2$exports.play("ding2", {
        gain: gain
    });
    const triangle = $3d5a7a21f49e3736$export$8061040b42890c32.find((p)=>p.name === name);
    triangle.style = "active";
    const complete = $c2fc41d0cd52f73e$export$364cd37066d27690();
    setTimeout(()=>{
        if (!complete) {
            if (zoomBack) $c2fc41d0cd52f73e$var$zoomBackToPlayer();
        } else $c2fc41d0cd52f73e$var$animateStonehengeComplete();
    }, 2000);
}
function $c2fc41d0cd52f73e$var$animateStonehengeComplete() {
    $cdce0d2b992d5ef2$exports.play("ding-final");
    const center = $3d5a7a21f49e3736$export$8061040b42890c32.find((p)=>p.name === "stonehenge-center");
    center.style = "complete";
    setTimeout(()=>{
        $c2fc41d0cd52f73e$var$zoomBackToPlayer();
    }, 2000);
}
function $c2fc41d0cd52f73e$var$zoomBackToPlayer() {
    $ccec0efdcdb6886e$export$a66bf038d7620ad7();
    setTimeout(()=>{
        $74f1281c4255ba38$export$e506a1d27d1eaa20.controllable = true;
    }, 2000);
}


// NOTE: IDEA: Should there be a faint trace of the grudge drawn on the floor?
let $c03b8a7fe0c66f23$var$whistlePanner;
const $c03b8a7fe0c66f23$var$POIs = [
    {
        name: "grudge",
        position: {
            x: -26,
            y: 11,
            z: 0.5
        },
        color: "violet",
        hideOnMap: true,
        sound: {
            name: "grudge",
            gain: 0
        },
        wander: {
            mode: "loop",
            points: [
                {
                    x: -26,
                    y: 11,
                    z: 0.5,
                    s: 1
                },
                {
                    x: -28,
                    y: -4,
                    z: 0.5,
                    s: 1
                },
                {
                    x: -19,
                    y: -19,
                    z: 0.5,
                    s: 1
                },
                {
                    x: -4,
                    y: -14,
                    z: 0.5,
                    s: 1
                },
                {
                    x: 7,
                    y: -20,
                    z: 0.5,
                    s: 1
                },
                {
                    x: 16,
                    y: 8,
                    z: 0.5,
                    s: 1
                },
                {
                    x: -9,
                    y: 14,
                    z: 0.5,
                    s: 1
                }
            ],
            pause (callback) {
                // FIXME: There should be a better way to get this POI main sound source reference
                //        Maybe the pause method should be on POIs root ?
                const p = $3d5a7a21f49e3736$export$8061040b42890c32.find((p)=>p.name === "grudge");
                // Fade out the main POI sound
                p.sound.source.fade();
                // Position the whistle panner and play the sound once
                $c03b8a7fe0c66f23$var$whistlePanner.positionPanner(p.position.x, p.position.z, p.position.y);
                $cdce0d2b992d5ef2$exports.play("whistle", {
                    destination: $c03b8a7fe0c66f23$var$whistlePanner,
                    gain: 0
                });
                // Drop key
                $c2fc41d0cd52f73e$export$663103110d94aac9("stonehenge-triangle-8", p.position, {
                    collisionRadius: 0.5,
                    despawn: 12,
                    offset: {
                        x: 0.8,
                        y: -0.8
                    }
                });
                setTimeout(()=>{
                    p.sound.source.fadeTo(2, 0, -90);
                    callback();
                }, 12000);
            }
        },
        async onStart () {
            $159fa085cd4c746e$exports.play(this);
            $c03b8a7fe0c66f23$var$whistlePanner = $159fa085cd4c746e$exports.createPanner();
        }
    }
];
var $9ceeaaad73c765b5$exports = {};

$9ceeaaad73c765b5$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../GrudgeComplet.90e25522.wav";


var $56c807b41e676a60$exports = {};

$56c807b41e676a60$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../GrudgeSiffle.e58caf57.wav";


const $c03b8a7fe0c66f23$var$sounds = [
    {
        name: "grudge",
        url: new URL($9ceeaaad73c765b5$exports)
    },
    {
        name: "whistle",
        url: new URL($56c807b41e676a60$exports)
    }
];
const $c03b8a7fe0c66f23$var$images = [];
function $c03b8a7fe0c66f23$export$2cd8252107eb640b() {
    $3d5a7a21f49e3736$export$1d3a1dba469744a6($c03b8a7fe0c66f23$var$POIs);
    //loader.addImages(images);
    $9e3987a94d403814$export$cb43b96ee3d96841($c03b8a7fe0c66f23$var$sounds);
}







let $4c9f8b5bd849a2cf$var$hydroSound;
const $4c9f8b5bd849a2cf$var$POIs = [
    {
        name: "lake",
        position: {
            x: -10,
            y: -22,
            z: 0
        },
        image: "lake",
        sound: {
            name: "swamp",
            gain: 0
        },
        symbolic: false,
        collision: {
            radius: 4
        },
        async onEnter () {
            $cdce0d2b992d5ef2$exports.play("lakePlouf");
            $4c9f8b5bd849a2cf$var$hydroSound = await $cdce0d2b992d5ef2$exports.play("hydro", {
                loop: true,
                gain: 0,
                when: 0.6
            });
            $74f1281c4255ba38$export$e506a1d27d1eaa20.maxVelocity = 1;
            $c2fc41d0cd52f73e$export$663103110d94aac9("stonehenge-triangle-1", this.position, {
                collisionRadius: 0.5,
                delay: 5,
                offset: {
                    x: 1.5,
                    y: -2
                }
            });
        },
        onLeave () {
            $cdce0d2b992d5ef2$exports.play("lakeOut", {
                gain: 0
            });
            $4c9f8b5bd849a2cf$var$hydroSound.stop();
            $74f1281c4255ba38$export$e506a1d27d1eaa20.maxVelocity = 2.5;
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    }
];

var $a2426d2925cb92da$exports = {};

$a2426d2925cb92da$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../MaraisPlouf.07309f16.wav";


var $f8c7354cc2a0ed20$exports = {};

$f8c7354cc2a0ed20$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../MaraisOut.834e10a8.wav";


const $4c9f8b5bd849a2cf$var$sounds = [
    {
        name: "hydro",
        url: new URL($9ab879debbcb5593$exports)
    },
    {
        name: "lakePlouf",
        url: new URL($a2426d2925cb92da$exports)
    },
    {
        name: "lakeOut",
        url: new URL($f8c7354cc2a0ed20$exports)
    }
];
var $6559e00754229967$exports = {};

$6559e00754229967$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../lake.aea94cbb.png";


const $4c9f8b5bd849a2cf$var$images = [
    {
        name: "lake",
        url: new URL($6559e00754229967$exports),
        ppm: 25
    }
];
function $4c9f8b5bd849a2cf$export$2cd8252107eb640b() {
    $3d5a7a21f49e3736$export$1d3a1dba469744a6($4c9f8b5bd849a2cf$var$POIs);
    $9e3987a94d403814$export$8250d5b41185d62d($4c9f8b5bd849a2cf$var$images);
    $9e3987a94d403814$export$cb43b96ee3d96841($4c9f8b5bd849a2cf$var$sounds);
}








let $f723e489bc76021d$var$mosquito;
let $f723e489bc76021d$var$moskitoPanner;
const $f723e489bc76021d$var$POIs = [
    {
        name: "swamp",
        position: {
            x: 24,
            y: 4,
            z: 0
        },
        image: "swamp",
        symbolic: false,
        sound: {
            name: "swamp",
            gain: 0
        },
        collision: {
            radius: 2.4
        },
        async onEnter () {
            $f723e489bc76021d$var$moskitoPanner.positionPanner(this.position.x, this.position.z, this.position.y); // TODO: just pass pos !
            $f723e489bc76021d$var$mosquito = await $cdce0d2b992d5ef2$exports.play("mosquito", {
                loop: true,
                gain: 0,
                destination: $f723e489bc76021d$var$moskitoPanner
            });
            // TODO: make the mosquito spin around
            $74f1281c4255ba38$export$e506a1d27d1eaa20.maxVelocity = 1.4;
            $c2fc41d0cd52f73e$export$663103110d94aac9("stonehenge-triangle-3", this.position, {
                collisionRadius: 0.5,
                delay: 5
            });
        },
        onLeave () {
            $f723e489bc76021d$var$mosquito.fade(2, -90, true);
            $74f1281c4255ba38$export$e506a1d27d1eaa20.maxVelocity = 2.5;
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    }
];
var $d331fccedcd8b767$exports = {};

$d331fccedcd8b767$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Moskito.2c9991b5.wav";


var $1f73c66d33ed8657$exports = {};

$1f73c66d33ed8657$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Marais.9e279127.wav";


const $f723e489bc76021d$var$sounds = [
    {
        name: "mosquito",
        url: new URL($d331fccedcd8b767$exports)
    },
    {
        name: "swamp",
        url: new URL($1f73c66d33ed8657$exports)
    }
];
var $69536032e0311d7a$exports = {};

$69536032e0311d7a$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../swamp.433342ed.png";


const $f723e489bc76021d$var$images = [
    {
        name: "swamp",
        url: new URL($69536032e0311d7a$exports),
        ppm: 25
    }
];
function $f723e489bc76021d$export$2cd8252107eb640b() {
    $3d5a7a21f49e3736$export$1d3a1dba469744a6($f723e489bc76021d$var$POIs);
    $9e3987a94d403814$export$8250d5b41185d62d($f723e489bc76021d$var$images);
    $9e3987a94d403814$export$cb43b96ee3d96841($f723e489bc76021d$var$sounds);
    $f723e489bc76021d$var$moskitoPanner = (0, $159fa085cd4c746e$export$604289ae06b8fa82)();
}






const $fbd67f8ed7615f8a$var$POIs = [
    {
        name: "chat",
        position: {
            x: 20,
            y: -14,
            z: 0
        },
        color: "white",
        sound: {
            name: "chat",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    }
];
var $d19cbada39af4844$exports = {};

$d19cbada39af4844$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Chat.1696e156.wav";


const $fbd67f8ed7615f8a$var$sounds = [
    {
        name: "chat",
        url: new URL($d19cbada39af4844$exports)
    }
];
const $fbd67f8ed7615f8a$var$images = [];
function $fbd67f8ed7615f8a$export$2cd8252107eb640b() {
    $3d5a7a21f49e3736$export$1d3a1dba469744a6($fbd67f8ed7615f8a$var$POIs);
    //loader.addImages(images);
    $9e3987a94d403814$export$cb43b96ee3d96841($fbd67f8ed7615f8a$var$sounds);
}






const $23f9ba10b0e778d2$var$POIs = [
    {
        name: "chewing-gum",
        position: {
            x: -19,
            y: -13,
            z: 0
        },
        color: "white",
        sound: {
            name: "chewing-gum",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    }
];
var $14197270c29b762c$exports = {};

$14197270c29b762c$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../ChewingGum.ae6dd0e2.wav";


const $23f9ba10b0e778d2$var$sounds = [
    {
        name: "chewing-gum",
        url: new URL($14197270c29b762c$exports)
    }
];
const $23f9ba10b0e778d2$var$images = [];
function $23f9ba10b0e778d2$export$2cd8252107eb640b() {
    $3d5a7a21f49e3736$export$1d3a1dba469744a6($23f9ba10b0e778d2$var$POIs);
    //loader.addImages(images);
    $9e3987a94d403814$export$cb43b96ee3d96841($23f9ba10b0e778d2$var$sounds);
}







let $203366ff7b46c158$var$pedaloSound;
const $203366ff7b46c158$var$POIs = [
    {
        name: "pedalo",
        position: {
            x: 8,
            y: -27,
            z: 0
        },
        color: "blue",
        radius: 5,
        sound: {
            name: "pedalo-idle",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        },
        collision: {
            radius: 1
        },
        async onEnter () {
            // Follow player
            $203366ff7b46c158$var$pedaloSound = await $cdce0d2b992d5ef2$exports.play("pedalo", {
                loop: true,
                gain: 0
            });
            const originalPosition = {
                ...this.position
            };
            new (0, $f21970a667725935$export$208a41d6b4e37b97)(this.position, $74f1281c4255ba38$export$5880b8b5730aff45, 1, "easeOutQuad", (v)=>{
                this.sound.panner.positionPanner(v.x, v.z, v.y);
            }, (tween)=>{
                setTimeout(()=>{
                    // Manual cleanup to stop following player
                    tween.dispose();
                    $203366ff7b46c158$var$pedaloSound.fade();
                    new (0, $f21970a667725935$export$208a41d6b4e37b97)(this.position, originalPosition, 4, "easeInOutQuad", (v)=>{
                        this.sound.panner.positionPanner(v.x, v.z, v.y);
                    });
                    new (0, $f21970a667725935$export$208a41d6b4e37b97)(12, 5, 2, "easeOutQuad", (v)=>{
                        this.radius = v;
                    });
                }, 10000);
            });
            // Increase radius to 15
            new (0, $f21970a667725935$export$208a41d6b4e37b97)(this.radius, 12, 0.5, "easeOutQuad", (v)=>{
                this.radius = v;
            });
        }
    }
];
var $37c16df3a0a4973d$exports = {};

$37c16df3a0a4973d$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Pedalo_pause.223fcbb8.wav";


var $6a052bc906d2ed51$exports = {};

$6a052bc906d2ed51$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Pedalo.e7f2b40c.wav";


const $203366ff7b46c158$var$sounds = [
    {
        name: "pedalo-idle",
        url: new URL($37c16df3a0a4973d$exports)
    },
    {
        name: "pedalo",
        url: new URL($6a052bc906d2ed51$exports)
    }
];
const $203366ff7b46c158$var$images = [];
function $203366ff7b46c158$export$2cd8252107eb640b() {
    $3d5a7a21f49e3736$export$1d3a1dba469744a6($203366ff7b46c158$var$POIs);
    //loader.addImages(images);
    $9e3987a94d403814$export$cb43b96ee3d96841($203366ff7b46c158$var$sounds);
}







let $9781f2d1a8f3021e$var$moteurSound;
const $9781f2d1a8f3021e$var$POIs = [
    {
        name: "moteur",
        position: {
            x: 38,
            y: -8,
            z: 0
        },
        color: "red",
        radius: 5,
        sound: {
            name: "moteur-idle",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        },
        collision: {
            radius: 1
        },
        async onEnter () {
            // Follow player
            $9781f2d1a8f3021e$var$moteurSound = await $cdce0d2b992d5ef2$exports.play("moteur", {
                loop: true,
                gain: 0
            });
            const originalPosition = {
                ...this.position
            };
            new (0, $f21970a667725935$export$208a41d6b4e37b97)(this.position, $74f1281c4255ba38$export$5880b8b5730aff45, 1, "easeOutQuad", (v)=>{
                this.sound.panner.positionPanner(v.x, v.z, v.y);
            }, (tween)=>{
                setTimeout(()=>{
                    // Manual cleanup to stop following player
                    tween.dispose();
                    $9781f2d1a8f3021e$var$moteurSound.fade();
                    new (0, $f21970a667725935$export$208a41d6b4e37b97)(this.position, originalPosition, 4, "easeInOutQuad", (v)=>{
                        this.sound.panner.positionPanner(v.x, v.z, v.y);
                    });
                    new (0, $f21970a667725935$export$208a41d6b4e37b97)(12, 5, 2, "easeOutQuad", (v)=>{
                        this.radius = v;
                    });
                }, 10000);
            });
            // Increase radius to 15
            new (0, $f21970a667725935$export$208a41d6b4e37b97)(this.radius, 12, 0.5, "easeOutQuad", (v)=>{
                this.radius = v;
            });
        }
    }
];
var $365467638b1efa00$exports = {};

$365467638b1efa00$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Moteur_pause.9b741378.wav";


var $7e74c6717dea6e48$exports = {};

$7e74c6717dea6e48$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Moteur.f8878ae3.wav";


const $9781f2d1a8f3021e$var$sounds = [
    {
        name: "moteur-idle",
        url: new URL($365467638b1efa00$exports)
    },
    {
        name: "moteur",
        url: new URL($7e74c6717dea6e48$exports)
    }
];
const $9781f2d1a8f3021e$var$images = [];
function $9781f2d1a8f3021e$export$2cd8252107eb640b() {
    $3d5a7a21f49e3736$export$1d3a1dba469744a6($9781f2d1a8f3021e$var$POIs);
    //loader.addImages(images);
    $9e3987a94d403814$export$cb43b96ee3d96841($9781f2d1a8f3021e$var$sounds);
}






let $985f7d263fa969ef$var$melopee;
const $985f7d263fa969ef$var$pluieGain = 12;
const $985f7d263fa969ef$var$POIs = [
    {
        name: "pluie",
        position: {
            x: -23,
            y: 8,
            z: 0
        },
        color: "hsl(225, 100%, 50%)",
        sound: {
            name: "pluie",
            gain: $985f7d263fa969ef$var$pluieGain
        },
        collision: {
            radius: 2
        },
        async onEnter () {
            this.sound.source.fadeTo(2, -90, $985f7d263fa969ef$var$pluieGain);
            this.collision.radius = 4;
            $985f7d263fa969ef$var$melopee = await $cdce0d2b992d5ef2$exports.play("melopee", {
                destination: this.sound.panner,
                gain: 0,
                when: 2
            });
            $c2fc41d0cd52f73e$export$663103110d94aac9("stonehenge-triangle-7", this.position, {
                collisionRadius: 0.5,
                delay: 8
            });
        },
        onLeave () {
            this.sound.source.fadeTo(2, $985f7d263fa969ef$var$pluieGain, -90);
            this.collision.radius = 2;
            $985f7d263fa969ef$var$melopee?.fade(2, -90, true);
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    }
];
var $3f450488afb562c5$exports = {};

$3f450488afb562c5$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../PluieLegere_canopee.1425763c.wav";


var $dd6694e04d841d33$exports = {};

$dd6694e04d841d33$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Melopee_sirene.ca25a133.wav";


const $985f7d263fa969ef$var$sounds = [
    {
        name: "pluie",
        url: new URL($3f450488afb562c5$exports)
    },
    {
        name: "melopee",
        url: new URL($dd6694e04d841d33$exports)
    }
];
const $985f7d263fa969ef$var$images = [];
function $985f7d263fa969ef$export$2cd8252107eb640b() {
    $3d5a7a21f49e3736$export$1d3a1dba469744a6($985f7d263fa969ef$var$POIs);
    //loader.addImages(images);
    $9e3987a94d403814$export$cb43b96ee3d96841($985f7d263fa969ef$var$sounds);
}







let $e2fe48d8c4e01fb4$var$veloSound;
const $e2fe48d8c4e01fb4$var$POIs = [
    {
        name: "velo",
        position: {
            x: -18,
            y: 20,
            z: 0
        },
        color: "orange",
        radius: 5,
        sound: {
            name: "velo-idle",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        },
        collision: {
            radius: 1
        },
        async onEnter () {
            // Follow player
            this.sound.source.fadeTo(1, -90, -12);
            $e2fe48d8c4e01fb4$var$veloSound = await $cdce0d2b992d5ef2$exports.play("velo", {
                loop: true,
                gain: 0
            });
            const originalPosition = {
                ...this.position
            };
            new (0, $f21970a667725935$export$208a41d6b4e37b97)(this.position, $74f1281c4255ba38$export$5880b8b5730aff45, 1, "easeOutQuad", (v)=>{
                this.sound.panner.positionPanner(v.x, v.z, v.y);
            }, (tween)=>{
                setTimeout(()=>{
                    this.sound.source.fadeTo(1, -12, -90);
                    // Manual cleanup to stop following player
                    tween.dispose();
                    $e2fe48d8c4e01fb4$var$veloSound.fade();
                    new (0, $f21970a667725935$export$208a41d6b4e37b97)(this.position, originalPosition, 4, "easeInOutQuad", (v)=>{
                        this.sound.panner.positionPanner(v.x, v.z, v.y);
                    });
                    new (0, $f21970a667725935$export$208a41d6b4e37b97)(12, 5, 2, "easeOutQuad", (v)=>{
                        this.radius = v;
                    });
                }, 10000);
            });
            // Increase radius to 15
            new (0, $f21970a667725935$export$208a41d6b4e37b97)(this.radius, 12, 0.5, "easeOutQuad", (v)=>{
                this.radius = v;
            });
        }
    }
];
var $11558d27dc725cd6$exports = {};

$11558d27dc725cd6$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../SonetteCourte.f8b587f8.wav";


var $77813e7323ee55de$exports = {};

$77813e7323ee55de$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../ChaineVelo.9f0a6bab.wav";


const $e2fe48d8c4e01fb4$var$sounds = [
    {
        name: "velo-idle",
        url: new URL($11558d27dc725cd6$exports)
    },
    {
        name: "velo",
        url: new URL($77813e7323ee55de$exports)
    }
];
const $e2fe48d8c4e01fb4$var$images = [];
function $e2fe48d8c4e01fb4$export$2cd8252107eb640b() {
    $3d5a7a21f49e3736$export$1d3a1dba469744a6($e2fe48d8c4e01fb4$var$POIs);
    //loader.addImages(images);
    $9e3987a94d403814$export$cb43b96ee3d96841($e2fe48d8c4e01fb4$var$sounds);
}






const $be11a3b4c99f67b4$var$POIs = [
    {
        name: "dialogue-l",
        position: {
            x: -31,
            y: -7,
            z: 0
        },
        color: "white",
        sound: {
            name: "dialogue-l",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "dialogue-r",
        position: {
            x: -29,
            y: -8,
            z: 0
        },
        color: "white",
        sound: {
            name: "dialogue-r",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    }
];
var $e10c9bd7c1915edb$exports = {};

$e10c9bd7c1915edb$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../DialogueBizarreL.30378a28.wav";


var $46551863adab815a$exports = {};

$46551863adab815a$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../DialogueBizarreR.d09acdcf.wav";


const $be11a3b4c99f67b4$var$sounds = [
    {
        name: "dialogue-l",
        url: new URL($e10c9bd7c1915edb$exports)
    },
    {
        name: "dialogue-r",
        url: new URL($46551863adab815a$exports)
    }
];
const $be11a3b4c99f67b4$var$images = [];
function $be11a3b4c99f67b4$export$2cd8252107eb640b() {
    $3d5a7a21f49e3736$export$1d3a1dba469744a6($be11a3b4c99f67b4$var$POIs);
    //loader.addImages(images);
    $9e3987a94d403814$export$cb43b96ee3d96841($be11a3b4c99f67b4$var$sounds);
}






const $9c5fe5a05fa9ab0f$var$POIs = [
    {
        name: "machine-1",
        position: {
            x: 31,
            y: -26,
            z: 0
        },
        color: "white",
        sound: {
            name: "machine-1",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "machine-2",
        position: {
            x: 34,
            y: -27,
            z: 0
        },
        color: "white",
        sound: {
            name: "machine-2",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "machine-3",
        position: {
            x: 35,
            y: -24,
            z: 0
        },
        color: "white",
        sound: {
            name: "machine-3",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "machine-4",
        position: {
            x: 32,
            y: -23,
            z: 0
        },
        color: "white",
        sound: {
            name: "machine-4",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "espace",
        position: {
            x: 33,
            y: -25,
            z: 0
        },
        color: "white",
        invisible: true,
        collision: {
            radius: 3
        },
        onEnter () {
            $c2fc41d0cd52f73e$export$663103110d94aac9("stonehenge-triangle-2", this.position, {
                collisionRadius: 0.5,
                delay: 5,
                offset: {
                    x: 3,
                    y: -2
                }
            });
        },
        onLeave () {
            $cdce0d2b992d5ef2$exports.play("espace", {
                gain: 0
            });
        }
    }
];
var $741aeeb2ea59610a$exports = {};

$741aeeb2ea59610a$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Usine1.42b6a4a7.wav";


var $b579693ef3a9e9df$exports = {};

$b579693ef3a9e9df$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Usine2.379f6384.wav";


var $13f1b3f03fafb892$exports = {};

$13f1b3f03fafb892$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Usine3.f19dcc23.wav";


var $09ef5fadf195f087$exports = {};

$09ef5fadf195f087$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Usine4.96ea14c8.wav";


var $e7f9e0820cb4319c$exports = {};

$e7f9e0820cb4319c$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Espace.273b06d3.wav";


const $9c5fe5a05fa9ab0f$var$sounds = [
    {
        name: "machine-1",
        url: new URL($741aeeb2ea59610a$exports)
    },
    {
        name: "machine-2",
        url: new URL($b579693ef3a9e9df$exports)
    },
    {
        name: "machine-3",
        url: new URL($13f1b3f03fafb892$exports)
    },
    {
        name: "machine-4",
        url: new URL($09ef5fadf195f087$exports)
    },
    {
        name: "espace",
        url: new URL($e7f9e0820cb4319c$exports)
    }
];
const $9c5fe5a05fa9ab0f$var$images = [];
function $9c5fe5a05fa9ab0f$export$2cd8252107eb640b() {
    $3d5a7a21f49e3736$export$1d3a1dba469744a6($9c5fe5a05fa9ab0f$var$POIs);
    //loader.addImages(images);
    $9e3987a94d403814$export$cb43b96ee3d96841($9c5fe5a05fa9ab0f$var$sounds);
}






const $77d372c22660fc5a$var$POIs = [
    {
        name: "couplet-1",
        position: {
            x: -33,
            y: 22,
            z: 0
        },
        color: "white",
        sound: {
            name: "couplet-1",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "couplet-2",
        position: {
            x: -35,
            y: 22,
            z: 0
        },
        color: "white",
        sound: {
            name: "couplet-2",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "couplet-3",
        position: {
            x: -35,
            y: 24,
            z: 0
        },
        color: "white",
        sound: {
            name: "couplet-3",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "couplet-4",
        position: {
            x: -33,
            y: 24,
            z: 0
        },
        color: "white",
        sound: {
            name: "couplet-4",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "couplet-5",
        position: {
            x: -34,
            y: 23,
            z: 0
        },
        color: "white",
        sound: {
            name: "couplet-5",
            gain: 0
        },
        collision: {
            radius: 1
        },
        onEnter () {
            $c2fc41d0cd52f73e$export$663103110d94aac9("stonehenge-triangle-6", this.position, {
                collisionRadius: 0.5,
                offset: {
                    x: -3,
                    y: 3
                },
                delay: 5,
                gain: 0
            });
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    }
];
var $a7c2b7bfa18edb71$exports = {};

$a7c2b7bfa18edb71$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Couplet1.b500094b.wav";


var $896c754fad58b9f2$exports = {};

$896c754fad58b9f2$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Couplet2.68f03748.wav";


var $9f6a139b23c04ed5$exports = {};

$9f6a139b23c04ed5$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Couplet3.2a6113c9.wav";


var $9db321de8c330dbc$exports = {};

$9db321de8c330dbc$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Couplet4.6ea6e560.wav";


var $b1670b463dbe9817$exports = {};

$b1670b463dbe9817$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Couplet5.3079d01f.wav";


const $77d372c22660fc5a$var$sounds = [
    {
        name: "couplet-1",
        url: new URL($a7c2b7bfa18edb71$exports)
    },
    {
        name: "couplet-2",
        url: new URL($896c754fad58b9f2$exports)
    },
    {
        name: "couplet-3",
        url: new URL($9f6a139b23c04ed5$exports)
    },
    {
        name: "couplet-4",
        url: new URL($9db321de8c330dbc$exports)
    },
    {
        name: "couplet-5",
        url: new URL($b1670b463dbe9817$exports)
    }
];
const $77d372c22660fc5a$var$images = [];
function $77d372c22660fc5a$export$2cd8252107eb640b() {
    $3d5a7a21f49e3736$export$1d3a1dba469744a6($77d372c22660fc5a$var$POIs);
    //loader.addImages(images);
    $9e3987a94d403814$export$cb43b96ee3d96841($77d372c22660fc5a$var$sounds);
}






const $5165e9c165699ec3$var$POIs = [
    {
        name: "hey-1",
        position: {
            x: 34,
            y: 24,
            z: 0
        },
        color: "white",
        sound: {
            name: "hey-1",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "hey-2",
        position: {
            x: 35,
            y: 25,
            z: 0
        },
        color: "white",
        sound: {
            name: "hey-2",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "hey-3",
        position: {
            x: 36,
            y: 26,
            z: 0
        },
        color: "white",
        sound: {
            name: "hey-3",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "hey-4",
        position: {
            x: 37,
            y: 27,
            z: 0
        },
        color: "white",
        sound: {
            name: "hey-4",
            gain: 0
        },
        collision: {
            radius: 1
        },
        onEnter () {
            $c2fc41d0cd52f73e$export$663103110d94aac9("stonehenge-triangle-4", this.position, {
                collisionRadius: 0.5,
                offset: {
                    x: 1,
                    y: 1
                },
                delay: 1
            });
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    }
];
var $2f93a009ca8789cb$exports = {};

$2f93a009ca8789cb$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Hey1.99eb2b1c.wav";


var $df1673d393d18370$exports = {};

$df1673d393d18370$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Hey2.6f8ad809.wav";


var $548c849995eeb156$exports = {};

$548c849995eeb156$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Hey3.191e5841.wav";


var $891ab3e93f5f4463$exports = {};

$891ab3e93f5f4463$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Hey4.ec71dfcc.wav";


const $5165e9c165699ec3$var$sounds = [
    {
        name: "hey-1",
        url: new URL($2f93a009ca8789cb$exports)
    },
    {
        name: "hey-2",
        url: new URL($df1673d393d18370$exports)
    },
    {
        name: "hey-3",
        url: new URL($548c849995eeb156$exports)
    },
    {
        name: "hey-4",
        url: new URL($891ab3e93f5f4463$exports)
    }
];
const $5165e9c165699ec3$var$images = [];
function $5165e9c165699ec3$export$2cd8252107eb640b() {
    $3d5a7a21f49e3736$export$1d3a1dba469744a6($5165e9c165699ec3$var$POIs);
    //loader.addImages(images);
    $9e3987a94d403814$export$cb43b96ee3d96841($5165e9c165699ec3$var$sounds);
}







const $557127b04cdfc1ee$var$POIs = [
    {
        name: "inspire-1",
        position: {
            x: 2,
            y: 21,
            z: 0
        },
        color: "white",
        sound: {
            name: "inspire-1",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "inspire-2",
        position: {
            x: 2,
            y: 22,
            z: 0
        },
        color: "white",
        sound: {
            name: "inspire-2",
            gain: 0,
            delay: 1.3
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "inspire-3",
        position: {
            x: 2,
            y: 23,
            z: 0
        },
        color: "white",
        sound: {
            name: "inspire-3",
            gain: 0,
            delay: 0.9
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "inspire-4",
        position: {
            x: 2,
            y: 24,
            z: 0
        },
        color: "white",
        sound: {
            name: "inspire-4",
            gain: 0,
            delay: 2.4
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "expire-1",
        position: {
            x: 4,
            y: 21,
            z: 0
        },
        color: "white",
        sound: {
            name: "expire-1",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "expire-2",
        position: {
            x: 4,
            y: 22,
            z: 0
        },
        color: "white",
        sound: {
            name: "expire-2",
            gain: 0,
            delay: 2.1
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "expire-3",
        position: {
            x: 4,
            y: 23,
            z: 0
        },
        color: "white",
        sound: {
            name: "expire-3",
            gain: 0,
            delay: 1.6
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "expire-4",
        position: {
            x: 4,
            y: 24,
            z: 0
        },
        color: "white",
        sound: {
            name: "expire-4",
            gain: 0,
            delay: 0.9
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    },
    {
        name: "respire",
        position: {
            x: 3,
            y: 22.5,
            z: 0
        },
        color: "white",
        invisible: true,
        collision: {
            radius: 3
        },
        onEnter () {
            $c2fc41d0cd52f73e$export$663103110d94aac9("stonehenge-triangle-5", this.position, {
                collisionRadius: 0.5,
                offset: {
                    x: 3,
                    y: 0
                },
                delay: 7,
                gain: 0
            });
        }
    }
];
var $7b12e3c3da7d95d9$exports = {};

$7b12e3c3da7d95d9$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Inspir1.285e5108.wav";


var $7597bbf463bf5713$exports = {};

$7597bbf463bf5713$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Inspir2.efd9e7aa.wav";


var $ef50caf9ee558e2c$exports = {};

$ef50caf9ee558e2c$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Inspir3.3c6e37bd.wav";


var $a64f1b3bb9ab485a$exports = {};

$a64f1b3bb9ab485a$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Inspir4.6318af05.wav";


var $a064143b5dbd9d61$exports = {};

$a064143b5dbd9d61$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Expir1.22119bdd.wav";


var $98c7a688c9e1a9c4$exports = {};

$98c7a688c9e1a9c4$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Expir2.f11f0986.wav";


var $19b8432a50497f8e$exports = {};

$19b8432a50497f8e$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Expir3.adfc6ee5.wav";


var $f8fb4564e7c18919$exports = {};

$f8fb4564e7c18919$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Expir4.f51f1076.wav";


const $557127b04cdfc1ee$var$sounds = [
    {
        name: "inspire-1",
        url: new URL($7b12e3c3da7d95d9$exports)
    },
    {
        name: "inspire-2",
        url: new URL($7597bbf463bf5713$exports)
    },
    {
        name: "inspire-3",
        url: new URL($ef50caf9ee558e2c$exports)
    },
    {
        name: "inspire-4",
        url: new URL($a64f1b3bb9ab485a$exports)
    },
    {
        name: "expire-1",
        url: new URL($a064143b5dbd9d61$exports)
    },
    {
        name: "expire-2",
        url: new URL($98c7a688c9e1a9c4$exports)
    },
    {
        name: "expire-3",
        url: new URL($19b8432a50497f8e$exports)
    },
    {
        name: "expire-4",
        url: new URL($f8fb4564e7c18919$exports)
    }
];
const $557127b04cdfc1ee$var$images = [];
function $557127b04cdfc1ee$export$2cd8252107eb640b() {
    $3d5a7a21f49e3736$export$1d3a1dba469744a6($557127b04cdfc1ee$var$POIs);
    //loader.addImages(images);
    $9e3987a94d403814$export$cb43b96ee3d96841($557127b04cdfc1ee$var$sounds);
}







let $fe34418de2f278d9$var$chameauSound;
const $fe34418de2f278d9$var$POIs = [
    {
        name: "chameau",
        position: {
            x: 22,
            y: 18,
            z: 0
        },
        color: "#7f5d49",
        radius: 5,
        sound: {
            name: "chameau-idle",
            gain: 0
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        },
        collision: {
            radius: 1
        },
        async onEnter () {
            // Follow player
            this.sound.source.fadeTo(1, -90, -12);
            $fe34418de2f278d9$var$chameauSound = await $cdce0d2b992d5ef2$exports.play("chameau", {
                loop: true,
                gain: 0
            });
            $74f1281c4255ba38$export$e506a1d27d1eaa20.maxVelocity = 1.5;
            const originalPosition = {
                ...this.position
            };
            new (0, $f21970a667725935$export$208a41d6b4e37b97)(this.position, $74f1281c4255ba38$export$5880b8b5730aff45, 1, "easeOutQuad", (v)=>{
                this.sound.panner.positionPanner(v.x, v.z, v.y);
            }, (tween)=>{
                setTimeout(()=>{
                    this.sound.source.fadeTo(1, -12, -90);
                    // Manual cleanup to stop following player
                    tween.dispose();
                    $fe34418de2f278d9$var$chameauSound.fade();
                    new (0, $f21970a667725935$export$208a41d6b4e37b97)(this.position, originalPosition, 4, "easeInOutQuad", (v)=>{
                        this.sound.panner.positionPanner(v.x, v.z, v.y);
                    });
                    new (0, $f21970a667725935$export$208a41d6b4e37b97)(12, 5, 2, "easeOutQuad", (v)=>{
                        this.radius = v;
                    });
                    $74f1281c4255ba38$export$e506a1d27d1eaa20.maxVelocity = 2.5;
                }, 10000);
            });
            // Increase radius to 15
            new (0, $f21970a667725935$export$208a41d6b4e37b97)(this.radius, 12, 0.5, "easeOutQuad", (v)=>{
                this.radius = v;
            });
        }
    }
];
var $b4159589f4a919c7$exports = {};

$b4159589f4a919c7$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Chameau_Pause.289721ad.wav";


var $ac7fe824318bc2b2$exports = {};

$ac7fe824318bc2b2$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../Chameau.b7416d89.wav";


const $fe34418de2f278d9$var$sounds = [
    {
        name: "chameau-idle",
        url: new URL($b4159589f4a919c7$exports)
    },
    {
        name: "chameau",
        url: new URL($ac7fe824318bc2b2$exports)
    }
];
const $fe34418de2f278d9$var$images = [];
function $fe34418de2f278d9$export$2cd8252107eb640b() {
    $3d5a7a21f49e3736$export$1d3a1dba469744a6($fe34418de2f278d9$var$POIs);
    //loader.addImages(images);
    $9e3987a94d403814$export$cb43b96ee3d96841($fe34418de2f278d9$var$sounds);
}







let $6721a1b733686611$var$voix;
const $6721a1b733686611$var$POIs = [
    {
        name: "telephone",
        position: {
            x: -7,
            y: 10,
            z: 0
        },
        color: "white",
        sound: {
            name: "telephone",
            gain: 0
        },
        collision: {
            radius: 1
        },
        async onEnter () {
            this.sound.source.fadeTo(0, -90, 0);
            $6721a1b733686611$var$voix = await $cdce0d2b992d5ef2$exports.play("voix", {
                destination: this.sound.panner,
                gain: 0
            });
        },
        onLeave () {
            this.sound.source.fadeTo(1, 0, -90);
            $6721a1b733686611$var$voix?.fade(1, -90, true);
        },
        onStart () {
            $159fa085cd4c746e$exports.play(this);
        }
    }
];
var $718e462fe7d81b6a$exports = {};

$718e462fe7d81b6a$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../telephone.11a028ce.wav";


var $7afc31c229601bdf$exports = {};

$7afc31c229601bdf$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../VoixTelephone.393e5d4f.wav";


const $6721a1b733686611$var$sounds = [
    {
        name: "telephone",
        url: new URL($718e462fe7d81b6a$exports)
    },
    {
        name: "voix",
        url: new URL($7afc31c229601bdf$exports)
    }
];
const $6721a1b733686611$var$images = [];
function $6721a1b733686611$export$2cd8252107eb640b() {
    $3d5a7a21f49e3736$export$1d3a1dba469744a6($6721a1b733686611$var$POIs);
    //loader.addImages(images);
    $9e3987a94d403814$export$cb43b96ee3d96841($6721a1b733686611$var$sounds);
}


let $3d5a7a21f49e3736$var$started = false;
// TODO: this module.config.whatever is too verbose, think about a better way to handle this
const $3d5a7a21f49e3736$export$e506a1d27d1eaa20 = {
    // All sizes in meters
    worldSize: {
        width: 80,
        height: 60
    },
    worldOrigin: {
        x: 40,
        y: 30
    },
    playerStart: {
        x: 0,
        y: 0
    }
};
const $3d5a7a21f49e3736$export$8061040b42890c32 = [];
let $3d5a7a21f49e3736$var$contactingBoundsSound;
var $d0d7002174e937a4$exports = {};

$d0d7002174e937a4$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../BarriereElectrique.183e8f59.wav";


var $1ba924bd99daa0a6$exports = {};

$1ba924bd99daa0a6$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../DingClewav.559f7c4f.wav";


var $d48d568e88597270$exports = {};

$d48d568e88597270$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../DingFinal.ebde80d2.wav";


var $7d7afaa06193e1e8$exports = {};

$7d7afaa06193e1e8$exports = (parcelRequire("aNJCr")).getBundleURL("hWIQf") + "../LabyrinthEcho.40a5104a.mp3";


function $3d5a7a21f49e3736$export$2cd8252107eb640b() {
    // Calculate world bounds
    $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldBounds = {};
    $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldBounds.top = $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldOrigin.y - $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldSize.height;
    $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldBounds.right = $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldSize.width - $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldOrigin.x;
    $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldBounds.bottom = $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldSize.height - $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldOrigin.y;
    $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldBounds.left = $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldOrigin.x - $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldSize.width;
    $71fd8a9a49abf6a2$export$2cd8252107eb640b();
    //demo.init();
    $c03b8a7fe0c66f23$export$2cd8252107eb640b();
    $4c9f8b5bd849a2cf$export$2cd8252107eb640b();
    $f723e489bc76021d$export$2cd8252107eb640b();
    $fbd67f8ed7615f8a$export$2cd8252107eb640b();
    $23f9ba10b0e778d2$export$2cd8252107eb640b();
    $203366ff7b46c158$export$2cd8252107eb640b();
    $9781f2d1a8f3021e$export$2cd8252107eb640b();
    $985f7d263fa969ef$export$2cd8252107eb640b();
    $e2fe48d8c4e01fb4$export$2cd8252107eb640b();
    $be11a3b4c99f67b4$export$2cd8252107eb640b();
    $9c5fe5a05fa9ab0f$export$2cd8252107eb640b();
    $77d372c22660fc5a$export$2cd8252107eb640b();
    $5165e9c165699ec3$export$2cd8252107eb640b();
    $557127b04cdfc1ee$export$2cd8252107eb640b();
    $fe34418de2f278d9$export$2cd8252107eb640b();
    $6721a1b733686611$export$2cd8252107eb640b();
    $9e3987a94d403814$export$cb43b96ee3d96841([
        {
            name: "barriere",
            url: new URL($d0d7002174e937a4$exports)
        },
        {
            name: "ding-pop",
            url: new URL($1ba924bd99daa0a6$exports)
        },
        {
            name: "ding-final",
            url: new URL($d48d568e88597270$exports)
        },
        {
            name: "labyrinthe-des-echos",
            url: new URL($7d7afaa06193e1e8$exports)
        }
    ]);
    return $9e3987a94d403814$export$2cd8252107eb640b();
}
function $3d5a7a21f49e3736$export$b3571188c770cc5a() {
    if (!$3d5a7a21f49e3736$var$started) {
        $3d5a7a21f49e3736$var$started = true;
        $3d5a7a21f49e3736$var$playSounds();
        $3d5a7a21f49e3736$var$startPOIs();
        (0, $4243735b17c41521$export$3274927b96bdf2f0)();
        $3d5a7a21f49e3736$var$startWanderers();
    }
}
function $3d5a7a21f49e3736$export$1d3a1dba469744a6(newPOIs) {
    $3d5a7a21f49e3736$export$8061040b42890c32.push(...newPOIs);
}
function $3d5a7a21f49e3736$var$playSounds() {
    $cdce0d2b992d5ef2$exports.play("barriere", {
        gain: -90,
        loop: true
    }).then((source)=>{
        $3d5a7a21f49e3736$var$contactingBoundsSound = source;
    });
// FIXME: Temporary psychoacoustic test
// TODO: Implement spatial reverb
// audio.buffers.play('bruit-de-fond', {
//     gain: 0, // in dB
//     loop: true,
// });
}
function $3d5a7a21f49e3736$var$startPOIs() {
    const POIsWithOnStart = $3d5a7a21f49e3736$export$8061040b42890c32.filter((p)=>p.onStart);
    POIsWithOnStart.forEach((p)=>{
        if (typeof p.onStart === "function") p.onStart();
    });
}
function $3d5a7a21f49e3736$export$722fbec263ad908a() {
    $3d5a7a21f49e3736$export$8061040b42890c32.forEach((p)=>{
        // Handle player collision
        if (p.collision) {
            const distance = Math.sqrt(Math.pow(p.position.x - $74f1281c4255ba38$export$5880b8b5730aff45.x, 2) + Math.pow(p.position.y - $74f1281c4255ba38$export$5880b8b5730aff45.y, 2));
            if (distance < p.collision.radius) {
                if (p.collision.active !== true) {
                    p.collision.active = true;
                    if (p.onEnter) p.onEnter();
                }
            } else if (p.collision.active === true) {
                p.collision.active = false;
                if (p.onLeave) p.onLeave();
            }
        }
    });
    // Play sound if player is touching the bounds
    if ($74f1281c4255ba38$export$ed594bb491455ccb) $3d5a7a21f49e3736$var$contactingBoundsSound?.fadeTo(0, 0);
    else $3d5a7a21f49e3736$var$contactingBoundsSound?.fadeTo(0, -90);
}
function $3d5a7a21f49e3736$var$startWanderers() {
    const wanderers = $3d5a7a21f49e3736$export$8061040b42890c32.filter((p)=>p.wander);
    wanderers.forEach((p)=>{
        $3d5a7a21f49e3736$var$createNextWandererTween(p, 1);
    });
}
function $3d5a7a21f49e3736$var$createNextWandererTween(p, i) {
    const time = Math.sqrt((p.position.x - p.wander.points[i].x) ** 2 + (p.position.y - p.wander.points[i].y) ** 2) / p.wander.points[i].s;
    new (0, $f21970a667725935$export$208a41d6b4e37b97)(p.position, p.wander.points[i], time, "linear", (v)=>{
        p.sound.panner.positionPanner(v.x, v.z, v.y);
    }, (tween)=>{
        tween.dispose();
        let nextIndex;
        switch(p.wander.mode){
            case "loop":
                nextIndex = (i + 1) % p.wander.points.length;
                break;
            case "once":
                if (i === p.wander.points.length - 1) return;
                nextIndex = (i + 1) % p.wander.points.length;
                break;
            case "pingpong":
                if (i === p.wander.points.length - 1) p.wander.backwards = true;
                if (i === 0) p.wander.backwards = false;
                nextIndex = p.wander.backwards ? i - 1 : i + 1;
                break;
        }
        if (p.wander.pause) p.wander.pause(()=>$3d5a7a21f49e3736$var$createNextWandererTween(p, nextIndex));
        else $3d5a7a21f49e3736$var$createNextWandererTween(p, nextIndex);
    });
}









let $6570a50b9be46a1f$var$canvas;
let $6570a50b9be46a1f$var$ratio;
let $6570a50b9be46a1f$var$pixelsPerMeter;
function $6570a50b9be46a1f$export$2cd8252107eb640b() {
    $6570a50b9be46a1f$var$ratio = $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldSize.width / $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldSize.height;
    $6570a50b9be46a1f$var$pixelsPerMeter = $a17d6d7671adcc59$export$e506a1d27d1eaa20.width / $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldSize.width;
    $6570a50b9be46a1f$var$canvas = document.createElement("canvas");
    $6570a50b9be46a1f$var$canvas.className = "map";
    $6570a50b9be46a1f$var$canvas.width = $a17d6d7671adcc59$export$e506a1d27d1eaa20.width;
    $6570a50b9be46a1f$var$canvas.height = $a17d6d7671adcc59$export$e506a1d27d1eaa20.height * 1 / $6570a50b9be46a1f$var$ratio;
}
function $6570a50b9be46a1f$export$f80a6900d44a74ee() {
    return $6570a50b9be46a1f$var$canvas;
}
function $6570a50b9be46a1f$export$e529deb2bfd496dc() {
    // Draw the map
    const ctx = $6570a50b9be46a1f$var$canvas.getContext("2d");
    // Clear the canvas
    ctx.fillStyle = "black";
    ctx.fillRect(0, 0, $6570a50b9be46a1f$var$canvas.width, $6570a50b9be46a1f$var$canvas.height);
    // Draw the point field
    // TODO: Think and move compass.config.pointSeparation and compass.config.pixelsPerMeter to scene ?
    const pointsInterval = $6570a50b9be46a1f$var$canvas.width / $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldSize.width * $ccec0efdcdb6886e$export$e506a1d27d1eaa20.pointSeparation;
    ctx.fillStyle = "#222";
    for(let x = 0; x <= $6570a50b9be46a1f$var$canvas.width; x += pointsInterval)for(let y = 0; y <= $6570a50b9be46a1f$var$canvas.height; y += pointsInterval)ctx.fillRect(x - 0.75, y - 0.75, 1.5, 1.5);
    // TODO: review the transforms here and apply same strategy to compass draws + try to generalize draws ?
    ctx.save();
    ctx.translate($3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldOrigin.x * $6570a50b9be46a1f$var$pixelsPerMeter, $3d5a7a21f49e3736$export$e506a1d27d1eaa20.worldOrigin.y * $6570a50b9be46a1f$var$pixelsPerMeter);
    $6570a50b9be46a1f$var$drawPOIs(ctx);
    $6570a50b9be46a1f$var$drawPlayer(ctx);
    ctx.restore();
// TODO: drawFogOfWar(ctx);
}
function $6570a50b9be46a1f$var$drawPlayer(ctx) {
    const playerX = $74f1281c4255ba38$export$5880b8b5730aff45.x * $6570a50b9be46a1f$var$pixelsPerMeter;
    const playerY = $74f1281c4255ba38$export$5880b8b5730aff45.y * $6570a50b9be46a1f$var$pixelsPerMeter;
    // Add translate and rotate to the transformation matrix for world coordinates
    // TODO: convert all other draws with initial transforms then local coordinates like this method
    ctx.save();
    ctx.translate(playerX, playerY);
    ctx.rotate((0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)($74f1281c4255ba38$export$9fddb9d0dd7d8a54));
    // Draw player
    ctx.beginPath();
    ctx.arc(0, 12, 8, (0, $4b341cc338785a8c$export$1ad3c7ead57ef8c)(0) - (0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(45), (0, $4b341cc338785a8c$export$1ad3c7ead57ef8c)(0) + (0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(45));
    ctx.lineTo(0, -8);
    ctx.closePath();
    ctx.fillStyle = "white";
    ctx.fill();
    // Restore transformation matrix to canvas coordinates
    ctx.restore();
}
function $6570a50b9be46a1f$var$drawPOIs(ctx) {
    const compassToMapRatio = $6570a50b9be46a1f$var$pixelsPerMeter / $ccec0efdcdb6886e$export$e506a1d27d1eaa20.pixelsPerMeter;
    // TODO: filter out POIs that are still in fog of war
    const visiblePOIs = $3d5a7a21f49e3736$export$8061040b42890c32.filter((p)=>!p.invisible);
    for (const p of visiblePOIs){
        if (p.hideOnMap) continue;
        const poiX = p.position.x * $6570a50b9be46a1f$var$pixelsPerMeter;
        const poiY = p.position.y * $6570a50b9be46a1f$var$pixelsPerMeter;
        ctx.save();
        ctx.translate(poiX, poiY);
        ctx.rotate((0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(p.rotation));
        ctx.scale(compassToMapRatio, compassToMapRatio);
        if (p.symbolic !== false) ctx.scale(2, 2); // Make it a bit bigger for the map
        ctx.fillStyle = p.color;
        ctx.beginPath();
        if (p.image) {
            // Draw image
            const imageWidth = $9e3987a94d403814$export$6c746a5570b8b35c[p.image].width;
            const imageHeight = $9e3987a94d403814$export$6c746a5570b8b35c[p.image].height;
            ctx.drawImage($9e3987a94d403814$export$6c746a5570b8b35c[p.image], -imageWidth / 2, -imageHeight / 2, imageWidth, imageHeight);
        } else if (p.type === "triangle") {
            // Draw a triangle centered on p.position
            ctx.beginPath();
            ctx.moveTo(Math.cos((0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(150)) * p.radius, Math.sin((0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(150)) * p.radius);
            ctx.lineTo(0, -p.radius);
            ctx.lineTo(Math.cos((0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(30)) * p.radius, Math.sin((0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(30)) * p.radius);
            ctx.closePath();
        } else if (p.type === "circle" || !p.type) // Draw circle (default type)
        ctx.arc(0, 0, p.radius || 5, 0, Math.PI * 2);
        // Handling for styled shapes
        if (!p.image) {
            if (!p.style) ctx.fill();
            else if (p.style === "idle") {
                ctx.fillStyle = "#99b";
                ctx.strokeStyle = "#99b";
                ctx.lineWidth = 1;
                ctx.fill();
                ctx.stroke();
            } else if (p.style === "active") {
                const timebase = Math.abs(Math.sin(Math.floor(Date.now() / 3 % 1000) / 1000 * Math.PI * 2));
                ctx.strokeStyle = p.color.replace("50%", `${timebase * 30 + 50}%`);
                ctx.lineWidth = 2;
                ctx.fill();
                ctx.stroke();
            }
        }
        ctx.restore();
    }
    // Draw Grudge path points as question marks
    const grudge = $3d5a7a21f49e3736$export$8061040b42890c32.find((p)=>p.name === "grudge");
    for (const point of grudge.wander.points){
        ctx.save();
        ctx.translate(point.x * $6570a50b9be46a1f$var$pixelsPerMeter, point.y * $6570a50b9be46a1f$var$pixelsPerMeter);
        ctx.font = "15px Helvetica Neue";
        ctx.fillStyle = "#666";
        ctx.fillText("?", 0, 0);
        ctx.restore();
    }
}



let $41cc4e3e034c1d5f$var$activeModal = null;
function $41cc4e3e034c1d5f$export$2cd8252107eb640b() {
    document.querySelector(".js-start").addEventListener("click", ()=>{
        if (DEVMODE) console.log("Starting...");
        document.querySelector("#menu").classList.add("hidden");
        document.querySelector("main").classList.remove("hidden");
        $65fe2578b15097c5$export$fbb4d68fe60c1629().then(()=>{
            $3d5a7a21f49e3736$export$b3571188c770cc5a();
        });
        $a17d6d7671adcc59$export$f9ef67375ddc185();
    });
    document.querySelector(".js-close").addEventListener("click", (event)=>{
        document.querySelector(".modal-wrapper").classList.add("hidden");
        $41cc4e3e034c1d5f$var$activeModal = null;
        $74f1281c4255ba38$export$e506a1d27d1eaa20.controllable = true;
    });
    document.querySelector(".modal-wrapper").addEventListener("click", (event)=>{
        if (event.target !== event.currentTarget) return;
        document.querySelector(".modal-wrapper").classList.add("hidden");
        $41cc4e3e034c1d5f$var$activeModal = null;
    });
}
function $41cc4e3e034c1d5f$export$471f7ae5c4103ae1(status) {
    const statusEl = document.querySelector("#status");
    if (status === null) statusEl.style.display = "none";
    statusEl.innerText = status;
}
function $41cc4e3e034c1d5f$export$978857af675b1906() {
    document.querySelector("#menu").classList.remove("hidden");
    $41cc4e3e034c1d5f$export$471f7ae5c4103ae1(null);
}
function $41cc4e3e034c1d5f$export$787f5d117f138d13(text, title = null) {
    if ($41cc4e3e034c1d5f$var$activeModal !== "message") {
        $41cc4e3e034c1d5f$var$activeModal = "message";
        document.querySelector(".modal-content").innerHTML = `
            <h2 class="title">${title}</h2>
            <p class="message">${text}</p>
        `.trim();
        document.querySelector(".modal-wrapper").classList.remove("hidden");
        $74f1281c4255ba38$export$e506a1d27d1eaa20.controllable = false;
    } else {
        $41cc4e3e034c1d5f$var$activeModal = null;
        document.querySelector(".modal-wrapper").classList.add("hidden");
        $74f1281c4255ba38$export$e506a1d27d1eaa20.controllable = true;
    }
}
function $41cc4e3e034c1d5f$export$c448526daa762015() {
    if ($41cc4e3e034c1d5f$var$activeModal !== "map") {
        $41cc4e3e034c1d5f$var$activeModal = "map";
        const modal = document.querySelector(".modal-content");
        modal.innerHTML = `
            <p>Carte</p>
        `.trim();
        modal.appendChild($6570a50b9be46a1f$export$f80a6900d44a74ee());
        $6570a50b9be46a1f$export$e529deb2bfd496dc();
        document.querySelector(".modal-wrapper").classList.remove("hidden");
        $74f1281c4255ba38$export$e506a1d27d1eaa20.controllable = false;
    } else {
        $41cc4e3e034c1d5f$var$activeModal = null;
        document.querySelector(".modal-wrapper").classList.add("hidden");
        $74f1281c4255ba38$export$e506a1d27d1eaa20.controllable = true;
    }
}





const $4243735b17c41521$var$keys = {};
let $4243735b17c41521$var$hotKeysEnabled = false;
function $4243735b17c41521$export$2cd8252107eb640b() {
    document.addEventListener("keydown", (e)=>{
        if (e.repeat) return;
        if (DEVMODE) console.log("Key down:", e.key);
        $4243735b17c41521$var$keys[e.key] = true;
        if (!$4243735b17c41521$var$hotKeysEnabled) return;
        switch(e.key){
            case "m":
                $41cc4e3e034c1d5f$export$c448526daa762015();
                break;
        }
        // FIXME: Debug only
        if (DEVMODE) {
            if ([
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8"
            ].includes(e.key)) $c2fc41d0cd52f73e$export$663103110d94aac9(`stonehenge-triangle-${e.key}`, $74f1281c4255ba38$export$5880b8b5730aff45, {
                offset: {
                    x: 1,
                    y: 1
                }
            });
            if (e.key === "0") {
                $c2fc41d0cd52f73e$export$2dabce2e5d7031d0("stonehenge-triangle-1");
                setTimeout(()=>$c2fc41d0cd52f73e$export$2dabce2e5d7031d0("stonehenge-triangle-2"), 100);
                setTimeout(()=>$c2fc41d0cd52f73e$export$2dabce2e5d7031d0("stonehenge-triangle-3"), 200);
                setTimeout(()=>$c2fc41d0cd52f73e$export$2dabce2e5d7031d0("stonehenge-triangle-4"), 300);
                setTimeout(()=>$c2fc41d0cd52f73e$export$2dabce2e5d7031d0("stonehenge-triangle-5"), 400);
                setTimeout(()=>$c2fc41d0cd52f73e$export$2dabce2e5d7031d0("stonehenge-triangle-6"), 500);
                setTimeout(()=>$c2fc41d0cd52f73e$export$2dabce2e5d7031d0("stonehenge-triangle-7"), 600);
                setTimeout(()=>$c2fc41d0cd52f73e$export$2dabce2e5d7031d0("stonehenge-triangle-8"), 700);
            }
            switch(e.key){
                case "z":
                    $ccec0efdcdb6886e$export$bdcc994deaedab19();
                    break;
                case "p":
                    $ccec0efdcdb6886e$export$a66bf038d7620ad7();
                    break;
            }
        }
    });
    document.addEventListener("keyup", (e)=>{
        $4243735b17c41521$var$keys[e.key] = false;
    });
}
function $4243735b17c41521$export$d081dc64f99d208b(key) {
    return !!$4243735b17c41521$var$keys[key];
}
function $4243735b17c41521$export$3274927b96bdf2f0(bool = true) {
    $4243735b17c41521$var$hotKeysEnabled = bool;
}







function $bdbe54e4c8db02fe$export$e529deb2bfd496dc() {
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fillStyle = "white";
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).font = "400 14px Dosis";
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fillText(`${Math.abs($74f1281c4255ba38$export$5880b8b5730aff45.y.toFixed(1))} m ${$74f1281c4255ba38$export$5880b8b5730aff45.y <= 0 ? "N" : "S"}`, 20, (0, $a17d6d7671adcc59$export$e506a1d27d1eaa20).height - 20);
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fillText(`${Math.abs($74f1281c4255ba38$export$5880b8b5730aff45.x.toFixed(1))} m ${$74f1281c4255ba38$export$5880b8b5730aff45.x >= 0 ? "E" : "O"}`, 20, (0, $a17d6d7671adcc59$export$e506a1d27d1eaa20).height - 35);
}






const $0a8b3bad0a47a20c$var$clickableAreas = [];
let $0a8b3bad0a47a20c$var$hovering = false;
const $0a8b3bad0a47a20c$var$clickCoordinates = {};
function $0a8b3bad0a47a20c$export$2cd8252107eb640b() {
    const canvasElement = document.querySelector("canvas");
    canvasElement.addEventListener("click", (e)=>{
        $0a8b3bad0a47a20c$var$clickCoordinates.x = e.clientX - canvasElement.offsetLeft;
        $0a8b3bad0a47a20c$var$clickCoordinates.y = e.clientY - canvasElement.offsetTop;
        $0a8b3bad0a47a20c$var$clickableAreas.forEach((area)=>{
            if ($0a8b3bad0a47a20c$var$clickCoordinates.x >= area.x && $0a8b3bad0a47a20c$var$clickCoordinates.x <= area.x + area.width && $0a8b3bad0a47a20c$var$clickCoordinates.y >= area.y && $0a8b3bad0a47a20c$var$clickCoordinates.y <= area.y + area.height) area.action();
        });
    });
    canvasElement.addEventListener("mousemove", (e)=>{
        $0a8b3bad0a47a20c$var$clickCoordinates.x = e.clientX - canvasElement.offsetLeft;
        $0a8b3bad0a47a20c$var$clickCoordinates.y = e.clientY - canvasElement.offsetTop;
        $0a8b3bad0a47a20c$var$hovering = false;
        $0a8b3bad0a47a20c$var$clickableAreas.forEach((area)=>{
            if ($0a8b3bad0a47a20c$var$clickCoordinates.x >= area.x && $0a8b3bad0a47a20c$var$clickCoordinates.x <= area.x + area.width && $0a8b3bad0a47a20c$var$clickCoordinates.y >= area.y && $0a8b3bad0a47a20c$var$clickCoordinates.y <= area.y + area.height) $0a8b3bad0a47a20c$var$hovering = true;
        });
        canvasElement.style.cursor = $0a8b3bad0a47a20c$var$hovering ? "pointer" : "default";
    });
}
function $0a8b3bad0a47a20c$export$ab34af9df4770788(area) {
    $0a8b3bad0a47a20c$var$clickableAreas.push(area);
}




function $cbbb2b2e711a4c8b$export$2cd8252107eb640b() {
    // Add mode toggle clickable area
    $0a8b3bad0a47a20c$export$ab34af9df4770788({
        x: (0, $a17d6d7671adcc59$export$e506a1d27d1eaa20).width - 45,
        y: 15,
        width: 30,
        height: 30,
        action: ()=>{
            $ccec0efdcdb6886e$export$ba03f2a005091f3b();
        }
    });
}
function $cbbb2b2e711a4c8b$export$e529deb2bfd496dc() {
    // Draw mode toggle circle
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).strokeStyle = "#666";
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).lineWidth = 2;
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).beginPath();
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).arc((0, $a17d6d7671adcc59$export$e506a1d27d1eaa20).width - 30, 30, 15, 0, Math.PI * 2);
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).stroke();
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fillStyle = "#ccc";
    if ($ccec0efdcdb6886e$export$1fc0f6205829e19c() === "heading-up") {
        // Draw heading icon
        (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).beginPath();
        (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).arc((0, $a17d6d7671adcc59$export$e506a1d27d1eaa20).width - 30, 42, 8, (0, $4b341cc338785a8c$export$1ad3c7ead57ef8c)(0) - (0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(45), (0, $4b341cc338785a8c$export$1ad3c7ead57ef8c)(0) + (0, $4b341cc338785a8c$export$e6bfdeff8bfc94f9)(45));
        (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).lineTo((0, $a17d6d7671adcc59$export$e506a1d27d1eaa20).width - 30, 22);
        (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).closePath();
        (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fill();
    } else {
        // Draw up indicator
        (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).beginPath();
        (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).moveTo((0, $a17d6d7671adcc59$export$e506a1d27d1eaa20).width - 26, 23);
        (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).lineTo((0, $a17d6d7671adcc59$export$e506a1d27d1eaa20).width - 30, 19);
        (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).lineTo((0, $a17d6d7671adcc59$export$e506a1d27d1eaa20).width - 34, 23);
        (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fill();
        // Draw north letter
        (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).font = "14px Helvetica Neue";
        (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fillText("N", (0, $a17d6d7671adcc59$export$e506a1d27d1eaa20).width - 35, 37);
    }
}





function $efeb78cc97cd234b$export$2cd8252107eb640b() {
    // Add mode toggle clickable area
    $0a8b3bad0a47a20c$export$ab34af9df4770788({
        x: 15,
        y: 15,
        width: 30,
        height: 30,
        action: ()=>{
            $41cc4e3e034c1d5f$export$c448526daa762015();
        }
    });
}
function $efeb78cc97cd234b$export$e529deb2bfd496dc() {
    // Draw mode toggle circle
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).strokeStyle = "#666";
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).lineWidth = 2;
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).beginPath();
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).arc(30, 30, 15, 0, Math.PI * 2);
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).stroke();
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fillStyle = "#ccc";
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).save();
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).translate(19.5, 19.5);
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).scale(18 / 512, 18 / 512);
    // From https://fontawesome.com/icons/user-astronaut?f=classic&s=solid
    const path = new Path2D("M376 120c0 7.4-2.7 19-9.4 35c-6.5 15.4-15.7 32.4-26.4 49.7c-17.1 27.8-36.9 54.7-52.2 74.4c-15.3-19.7-35.1-46.6-52.2-74.4c-10.7-17.3-19.9-34.3-26.4-49.7c-6.7-15.9-9.4-27.6-9.4-35c0-48.6 39.4-88 88-88s88 39.4 88 88zm32 0C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0C334.9 271.9 408 174.6 408 120zm-4.6 103.6c.9-.2 1.7-.4 2.5-.8L544 167.6V421.2L416 472.4V304c0-8.8-7.2-16-16-16s-16 7.2-16 16V474.8L192 419.9V304c0-8.8-7.2-16-16-16s-16 7.2-16 16V421.2L32 472.4V218.8l115.5-46.2c-3.9-10-7.2-20.4-9.2-30.8L15.1 191.1C6 194.8 0 203.6 0 213.4V484.2c0 17 17.1 28.6 32.9 22.3l144-57.6 218.7 62.5c3.4 1 7 .8 10.3-.5l155-62c9.1-3.6 15.1-12.5 15.1-22.3V155.8c0-17-17.1-28.6-32.9-22.3L425.2 180.7c-6.1 14.2-13.6 28.8-21.8 42.9z");
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).fill(path);
    (0, $ddc63e08d7bd2fae$export$39f92e86d1722f3a).restore();
}


function $e5dca62bf172cb4c$export$2cd8252107eb640b() {
    $ccec0efdcdb6886e$export$2cd8252107eb640b();
    $cbbb2b2e711a4c8b$export$2cd8252107eb640b();
    $efeb78cc97cd234b$export$2cd8252107eb640b();
}
function $e5dca62bf172cb4c$export$722fbec263ad908a() {
    $ccec0efdcdb6886e$export$722fbec263ad908a();
}
function $e5dca62bf172cb4c$export$e529deb2bfd496dc() {
    $ccec0efdcdb6886e$export$e529deb2bfd496dc();
    $bdbe54e4c8db02fe$export$e529deb2bfd496dc();
    $cbbb2b2e711a4c8b$export$e529deb2bfd496dc();
    $efeb78cc97cd234b$export$e529deb2bfd496dc();
}










window.DEVMODE = true;
// Constants
const $a17d6d7671adcc59$export$e506a1d27d1eaa20 = {
    width: 500,
    height: 500
};
// Variables
let $a17d6d7671adcc59$var$timeOfLastFrame = 0;
function $a17d6d7671adcc59$var$init() {
    $41cc4e3e034c1d5f$export$2cd8252107eb640b();
    $41cc4e3e034c1d5f$export$471f7ae5c4103ae1("Initializing...");
    $ddc63e08d7bd2fae$export$2cd8252107eb640b();
    $4243735b17c41521$export$2cd8252107eb640b();
    $169790e4820875e7$export$2cd8252107eb640b();
    $0a8b3bad0a47a20c$export$2cd8252107eb640b();
    $65fe2578b15097c5$export$2cd8252107eb640b();
    $e5dca62bf172cb4c$export$2cd8252107eb640b();
    $6570a50b9be46a1f$export$2cd8252107eb640b();
    $41cc4e3e034c1d5f$export$471f7ae5c4103ae1("Loading...");
    $3d5a7a21f49e3736$export$2cd8252107eb640b().then(()=>{
        $41cc4e3e034c1d5f$export$978857af675b1906();
    }).catch(()=>{
        $41cc4e3e034c1d5f$export$471f7ae5c4103ae1("Error while loading scene...");
    });
}
function $a17d6d7671adcc59$export$f9ef67375ddc185(time = 0) {
    const dt = (time - $a17d6d7671adcc59$var$timeOfLastFrame) / 1000;
    $a17d6d7671adcc59$var$update(dt);
    $a17d6d7671adcc59$var$draw();
    $a17d6d7671adcc59$var$timeOfLastFrame = time;
    requestAnimationFrame($a17d6d7671adcc59$export$f9ef67375ddc185);
}
function $a17d6d7671adcc59$var$update(dt) {
    $f21970a667725935$export$722fbec263ad908a(dt);
    $74f1281c4255ba38$export$722fbec263ad908a(dt);
    $3d5a7a21f49e3736$export$722fbec263ad908a();
    $e5dca62bf172cb4c$export$722fbec263ad908a();
}
function $a17d6d7671adcc59$var$draw() {
    $ddc63e08d7bd2fae$export$42ffd38884aecdac();
    $e5dca62bf172cb4c$export$e529deb2bfd496dc();
}
$a17d6d7671adcc59$var$init();

})();
//# sourceMappingURL=index.5f908643.js.map
